<template>
  <div class="gx-bb">
<!--    <h1 class="gx-main__title">资源盲盒</h1>-->
    <gx-loading :show="loading" />

    <div class="gx-bb__notice">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="flex-shrink: 0; margin-top: 1px;"><path d="M8 1.5l7 12H1L8 1.5z" stroke="#FB923C" stroke-width="1.3" stroke-linejoin="round"></path><path d="M8 6v4M8 12v.5" stroke="#FB923C" stroke-width="1.3" stroke-linecap="round"></path></svg>
      <p>
        <span style="color: rgb(251, 146, 60); font-weight: 600;">免责声明：</span>
        本站货盘将铺货到您店铺草稿箱，请您审核后再上架商品，上架后的商品出现任何违规，均与本站无关，使用本站即默认本条约!
      </p>
    </div>
    <div class="gx-bb__plat-tabs">
      <button
          v-for="p in platforms"
          :key="p.value"
          class="gx-bb__plat-tab"
          :class="{ 'gx-bb__plat-tab--on': searchData.shop_type === p.value }"
          @click="bindShopTypeChange(p.value)"
      >{{ p.label }}</button>
    </div>
    <div class="gx-bb__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item label="店铺分组：">
          <el-select v-model="searchData.group_ids" placeholder="全部分组" clearable
                     multiple collapse-tags filterable @change="setChange">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                       :value="item.id" />
            <el-option v-if="is_host" label="未分组" value="-1">未分组</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="searchData.shop_name" filterable placeholder="请选择" clearable >
            <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchData.shop_name_keyword" placeholder="店铺名称模糊搜索" clearable @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="盲盒状态：">
          <el-select v-model="searchData.daily_status" placeholder="全部" clearable class="w120">
            <el-option label="开启中" value="2"></el-option>
            <el-option label="已暂停" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盲盒策略：">
          <el-select v-model="searchData.blind_box_strategy" placeholder="全部" clearable filterable class="w160">
            <el-option label="未绑定" value="__unbound__"></el-option>
            <el-option v-for="item in strategyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="searchData.shop_type===7">
          <div class="gx-bb__spacer"></div>
          <button type="button" class="gx-bb__btn gx-bb__btn--danger" @click="handleSearch">查询</button>
          <button type="button" class="gx-bb__btn" @click="handleReset">重置</button>
        </template>
      </el-form>
      <template v-if="searchData.shop_type===1">
        <el-form inline size="mini">
          <el-form-item label="低动销店铺：" >
            <el-select v-model="searchData.low_sales" placeholder="全部" clearable class="w120" >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
              <el-option label="未知" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权下架低效品：">
            <el-select v-model="searchData.low_sales_product_delete_authorized" placeholder="全部" clearable class="w120">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="gx-bb__spacer"></div>
          <button type="button" class="gx-bb__btn gx-bb__btn--danger" @click="handleSearch">查询</button>
          <button type="button" class="gx-bb__btn" @click="handleReset">重置</button>
        </el-form>
        <div class="gx-bb__filter-tip" v-if="searchData.shop_type===1">动销率状态选项：未达标（＜1%）/ 已达标（≥1%）  ·  授权下架低效品：开启（已授权自动下架低效品）/ 关闭</div>
      </template>

    </div>

    <div class="gx-bb__batch-bar">
      <span>已选 {{ selectedShopIds.length }} 家店铺</span>
      <button type="button" class="gx-bb__btn gx-bb__btn--danger" :disabled="!selectedShopIds.length" @click="openBatchStrategy">批量设置策略</button>
      <button v-if="selectedShopIds.length" type="button" class="gx-bb__btn" @click="clearSelectedShops">清空已选</button>
      <div class="gx-bb__strategy-bar"><button style="background: #d4a946;" type="button" class="gx-bb__btn gx-bb__btn--danger" @click="openStrategyManager">盲盒策略管理</button></div>
    </div>

    <!--表格+分页-->
    <div class="table-page-wrapper">
        <div class="gx-bb__table">
          <table>
            <thead>
            <tr>
              <th :colspan="5">店铺信息</th>
              <th class="bg-red"><span class="text-red">额度管控</span></th>
              <th :colspan="3" class="bg-red" v-if="searchData.shop_type === 1"><span class="text-red" >动销考核（本系统30天考核窗口）</span></th>
              <th :colspan="searchData.shop_type === 1?3:1">风险拦截</th>
              <th>操作</th>
            </tr>
            <tr>
              <th><el-checkbox :value="isCurrentPageAllSelected" :indeterminate="isCurrentPagePartiallySelected" :disabled="!list.length" aria-label="全选当前页店铺" @change="toggleSelectAll" /></th>
              <th>
                <div>上货状态</div>
                <div class="gx-bb__th-dec">开启/关闭</div>
              </th>
              <th>店铺名称</th>
              <th>分组</th>
              <th>盲盒策略</th>
              <th class="bg-red">今日铺货额度</th>
              <template v-if="searchData.shop_type === 1">
                <th class="bg-red">
                  <div>动销率</div>
                  <div class="gx-bb__th-dec">目标≥1%</div>
                </th>
                <th class="bg-red">
                  <div>有效销量品</div>
                  <div class="gx-bb__th-dec">近30天</div>
                </th>
                <th class="bg-red">达标差距</th>
                <th>低动销店铺</th>
                <th>
                  <div>授权下架低效品</div>
                  <div class="gx-bb__th-dec">开启/关闭</div>
                </th>
              </template>
              <th>无SKU图拦截</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in list" :key="row.shop_id || i">
                <td><el-checkbox :value="isShopSelected(row)" :aria-label="`选择店铺${row.shop_name || row.mer_shop_id}`" @change="toggleShop(row, $event)" /></td>
                <td>
                  <button class="gx-bb__switch" :class="{ 'gx-bb__switch--on': row.daily_status == 2 }"  @click="toggleStatus(row)">
                    <span class="gx-bb__switch-dot"></span>
                  </button>
                </td>
                <td>
                  <div class="gx-bb__shop">
                    <div class="gx-bb__shop-icon">{{row.shop_name[0]}}</div>
                    <div style="min-width: 0">
                      <div class="gx-bb__shop-name">{{ row.shop_name || '--' }}</div>
                      <div class="gx-bb__shop-id">ID:{{ row.shop_id || '--' }}</div>
                    </div>
                  </div>
                </td>
                <td><span :class="{'gx-bb__tag--danger':row.group_name}">{{ row.group_name || '--' }}</span></td>
                <td><span class="gx-bb__tag">{{ row.blind_box_strategy ? row.blind_box_strategy.name : '未绑定' }}</span></td>
                <td class="bg-red">
                  <div class="gx-bb__quota">
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-black">{{ formatQuantity(getDailyPublishQuota(row)) }}</div>
                      <el-tooltip content="每日铺货总额度由接口 daily_publish_quota 提供，0也是有效额度。" placement="top">
                        <div class="gx-bb__td-label">总额度<i class="el-icon-info" style="margin-left: 3px;"></i></div>
                      </el-tooltip>
                    </div>
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-orange">{{ formatQuantity(row.today_success) }}</div>
                      <div class="gx-bb__td-label">已上</div>
                    </div>
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-green">{{ getRemainingQuota(row) }}</div>
                      <div class="gx-bb__td-label">剩余</div>
                    </div>
                  </div>
                </td>
                <template  v-if="searchData.shop_type === 1">
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatSalesRate(row) }}</div>
                    <div class="gx-bb__td-label">{{ getSalesAssessmentLabel(row) }}</div>
                  </td>
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatEffectiveSalesProductCount(row) }}</div>
                    <div class="gx-bb__td-label">{{ formatAppWindowOnlineProductCount(row) }}</div>
                  </td>
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatSalesGap(row) }}</div>
                    <div class="gx-bb__td-label">{{ formatSalesTarget(row) }}</div>
                  </td>
                  <td>
                    <span class="gx-bb__tag gx-bb__tag--success" v-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===true" type="danger">是</span>
                    <span class="gx-bb__tag gx-bb__tag--danger" v-else-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===false" type="success">否</span>
                    <span class="gx-bb__tag gx-bb__tag--info" v-else type="info">未知</span>
                  </td>
                  <td>
                    <el-tooltip v-if="isLowSalesAuthorizationDisableBlocked(row)" content="店铺商品应用授权仍有效且未到期，暂不能关闭‘授权下架低效品’。" placement="top">
                      <span class="gx-bb__switch-tooltip">
                        <button class="gx-bb__switch gx-bb__switch--on" disabled @click="updateLowSalesAuth(row)">
                          <span class="gx-bb__switch-dot"></span>
                        </button>
                      </span>
                    </el-tooltip>
                    <button v-else class="gx-bb__switch" :class="{ 'gx-bb__switch--on': row.low_sales_product_delete_authorized == 1 }" @click="updateLowSalesAuth(row)">
                      <span class="gx-bb__switch-dot"></span>
                    </button>
                  </td>
                </template>
                <td>
                  <!-- is_sku_miss_off 1是 2否-->
                  <span class="gx-bb__tag" :class="row.is_sku_miss_off != 2 ? 'gx-bb__tag--success' : 'gx-bb__tag--warn'">{{ row.is_sku_miss_off != 2 ? '未拦截' : '拦截中' }}</span>
                </td>
                <td>
                  <div class="gx-bb__ops">
                    <button class="gx-bb__op gx-bb__op--edit" @click="manageShop(row)">店铺资源</button>
                    <button v-if="row.blind_box_strategy && row.daily_status == 1" class="gx-bb__op gx-bb__op--edit" @click="unbindStrategy(row)">解绑</button>
                  </div>
                </td>
              </tr>
              <tr v-if="!list.length">
                <td :colspan="searchData.shop_type === 1 ? 13 : 8" class="gx-bb__empty">暂无盲盒数据</td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="page-wrap">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[ 20, 50, 100, 200, 500, 1000]" @pagination="getTableData(pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>
    <el-dialog title="盲盒策略管理" :visible.sync="strategyShow" :close-on-click-modal="false" width="920px" @open="loadStrategies">
      <div style="margin-bottom:12px"><el-button type="primary" size="mini" @click="newStrategy">新建策略</el-button></div>
      <el-table :data="strategyList" size="mini" border>
        <el-table-column prop="name" label="策略名称"/>
        <el-table-column prop="shop_count" label="绑定店铺" width="100"/>
        <el-table-column label="最近更新" width="180"><template #default="{row}">{{ formatStrategyUpdatedAt(row.updated_at) }}</template></el-table-column>
        <el-table-column label="操作" width="180"><template #default="{row}"><el-button size="mini" @click="editStrategy(row)">编辑</el-button><el-button size="mini" type="danger" @click="removeStrategy(row)">删除</el-button></template></el-table-column>
      </el-table>
      <el-dialog :title="strategyForm.id ? '编辑盲盒策略' : '新建盲盒策略'" :visible.sync="strategyFormShow" :close-on-click-modal="false" append-to-body width="660px">
        <el-form label-width="110px" size="mini">
          <el-form-item label="策略名称" required><el-input v-model.trim="strategyForm.name" maxlength="50"/></el-form-item>
          <el-form-item label="每日数量" required><el-input-number v-model="strategyForm.config.daily_num" :min="100" :max="500"/></el-form-item>
          <el-form-item label="上架策略" required><el-select v-model="strategyForm.config.strategies_id" filterable style="width:100%"><el-option v-for="item in listingStrategies" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item>
          <el-form-item label="限价区间" required>
            <div class="gx-bb__price-range">
              <span class="gx-bb__price-range-label">最低</span>
              <el-input-number v-model="strategyForm.config.shop_limit_price" :min="0" :precision="2" :controls="false" class="gx-bb__price-range-input" />
              <span class="gx-bb__price-range-unit">元</span>
              <span class="gx-bb__price-range-sep">~</span>
              <span class="gx-bb__price-range-label">最高</span>
              <el-input-number v-model="strategyForm.config.shop_limit_price_max" :min="0" :precision="2" :controls="false" class="gx-bb__price-range-input" />
              <span class="gx-bb__price-range-unit">元</span>
            </div>
            <div class="gx-bb__tip">铺货时只处理价格在此区间的商品；最高价填 0 表示不限制</div>
          </el-form-item>
          <el-form-item label="标题英文字母">
            <div class="gx-bb__inline-field">
              <el-input-number v-model="strategyForm.config.title_english_letter_min_count" :min="0" :max="255" :step="1" :precision="0" :controls="false" class="gx-bb__count-input" />
              <el-checkbox v-model="strategyForm.config.title_english_letter_consecutive" :true-label="1" :false-label="0" :disabled="!titleLetterFilterActive">仅过滤连续达到数量的标题</el-checkbox>
            </div>
            <div class="gx-bb__tip">标题中英文字母达到该数量时过滤，填<span style="font-size: 18px;color: red;font-weight: 700;"> 0 </span>表示不过滤，超过<span style="font-size: 18px;color: red;font-weight: 700;"> 30 </span>基本无品可用</div>
          </el-form-item>
          <el-form-item label="商品来源" required><el-input value="云商品库" disabled/></el-form-item>
          <el-form-item label="铺货类目" required>
            <el-cascader v-if="searchData.shop_type === 7" class="gx-bb__publish-cascader" v-model="strategyWechatCategoryPaths" :options="strategyCategoryTree" :props="strategyWechatCategoryProps" :disabled="strategyCategoryLoading || !strategyCategoryLoaded" :popper-append-to-body="false" clearable collapse-tags filterable style="width:100%" @change="onStrategyWechatCategoriesChange"/>
            <el-cascader v-else class="gx-bb__publish-cascader" v-model="strategyCategoryIds" :options="strategyCategoryTree" :props="strategyCategoryProps" :disabled="strategyCategoryLoading || !strategyCategoryLoaded" :show-all-levels="false" clearable collapse-tags filterable style="width:100%"/>
            <div class="gx-bb__tip" v-if="strategyCategoryLoading">正在加载铺货类目…</div>
            <div class="gx-bb__tip gx-bb__tip--red" v-else-if="strategyCategoryError">{{ strategyCategoryError }} <el-button type="text" size="mini" @click="loadStrategyCategoryTree">重试</el-button></div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="strategyCategoryInvalidIds.length">以下历史类目已失效：{{ strategyCategoryInvalidIds.join('、') }}。<el-button type="text" size="mini" @click="confirmRemoveInvalidStrategyCategories">确认移除</el-button></div>
          </el-form-item>
          <el-form-item label="SKU 状态"><el-select v-model="strategyForm.config.shop_product_repository_skus" multiple clearable style="width:100%"><el-option v-for="item in skuStatusOptions" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item>
          <el-form-item label="SKU 标记" v-if="searchData.shop_type === 1"><el-select v-model="strategyForm.config.shop_product_repository_skus_mark" multiple clearable style="width:100%"><el-option :value="1" label="未标记"/><el-option :value="2" label="已标记"/><el-option :value="3" label="找不到"/></el-select></el-form-item>
          <el-form-item label="云商品主分组">
            <el-select v-if="strategyGroupStatus === 'success'" :key="'strategy-main-groups-' + strategyGroupRequestId" v-model="strategyForm.config.shop_product_repository_groups" multiple clearable style="width:100%" @change="loadStrategyChildGroups">
              <el-option v-for="item in strategyGroupList" :key="item.id" :label="strategyMainGroupLabel(item)" :value="item.id" :disabled="isStrategyGroupOptionDisabled(item, strategyForm.config.shop_product_repository_groups)">
                <span>{{ item.name }}</span>
                <span v-if="item.is_shared" class="gx-bb__group-shared">共享</span>
                <span v-if="hasStrategyProductCount(item)" class="gx-bb__group-count">（{{ item.product_count }} 件）</span>
              </el-option>
            </el-select>
            <div class="gx-bb__tip" v-if="strategyGroupStatus === 'loading'">正在加载云商品分组…</div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="strategyGroupStatus === 'error'">主分组加载失败，请重试 <el-button type="text" size="mini" @click="loadStrategyGroupList">重试</el-button></div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="invalidStrategyMainGroupIds.length">存在已失效的主分组，请重新选择</div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="zeroProductStrategyMainGroupNames.length">已选主分组无商品：{{ zeroProductStrategyMainGroupNames.join('、') }}，请移除或改选</div>
          </el-form-item>
          <el-form-item label="云商品子分组" required v-if="strategyForm.config.shop_product_repository_groups.length">
            <el-select v-if="strategyChildGroupStatus === 'success'" :key="'strategy-child-groups-' + strategyChildGroupRequestId" v-model="strategyForm.config.shop_product_repository_child_groups" multiple clearable filterable style="width:100%">
              <el-option v-for="item in strategyChildGroups" :key="item.id" :label="strategyChildGroupLabel(item)" :value="item.id" :disabled="isStrategyGroupOptionDisabled(item, strategyForm.config.shop_product_repository_child_groups)">
                <span>{{ item.parent_name }} / {{ item.name }}</span>
                <span v-if="item.is_shared" class="gx-bb__group-shared">共享</span>
                <span v-if="hasStrategyProductCount(item)" class="gx-bb__group-count">（{{ item.product_count }} 件）</span>
              </el-option>
            </el-select>
            <div class="gx-bb__tip" v-if="strategyChildGroupStatus === 'loading'">正在加载云商品子分组…</div>
            <div class="gx-bb__tip gx-bb__tip--red" v-else-if="strategyChildGroupStatus === 'error'">子分组加载失败，请重试 <el-button type="text" size="mini" @click="loadStrategyGroupList">重试</el-button></div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="zeroProductStrategyChildGroupNames.length">已选子分组无商品：{{ zeroProductStrategyChildGroupNames.join('、') }}，请移除或改选</div>
            <div class="gx-bb__tip gx-bb__tip--red" v-if="strategyChildGroupStatus === 'success' && missingStrategyGroupNames.length">主分组 {{ missingStrategyGroupNames.join('、') }} 至少选择一个子分组</div>
          </el-form-item>
          <el-form-item label="SKU 图拦截" v-if="searchData.shop_type === 1"><el-switch v-model="strategyForm.config.is_sku_miss_off" :active-value="2" :inactive-value="1"/></el-form-item>
          <el-form-item label="抖店黑名单" v-if="searchData.shop_type === 1">
            <el-cascader
              class="gx-bb__blacklist-cascader"
              v-model="strategyBlacklistCategoryPaths"
              :options="strategyBlacklistCategoryTree"
              :props="strategyBlacklistCategoryProps"
              :disabled="strategyBlacklistCategoryLoading || !strategyBlacklistCategoryLoaded"
              :show-all-levels="false"
              clearable
              collapse-tags
              filterable
              placeholder="请选择不允许铺货的叶子类目"
              style="width:100%"
            />
            <div class="gx-bb__tip gx-bb__tip--red">设置“不允许铺货”的最末级商品类目，商品类目预测时会先排除黑名单项。</div>
            <div v-if="strategyBlacklistCategoryLoading" class="gx-bb__tip">正在加载抖店类目…</div>
            <div v-else-if="strategyBlacklistCategoryError" class="gx-bb__tip gx-bb__tip--red">
              黑名单类目加载失败，请重试。
              <el-button type="text" size="mini" @click="loadStrategyBlacklistCategoryTree(strategyForm.config.shop_category_blacklist_leaf_ids)">重试</el-button>
            </div>
            <div v-if="strategyBlacklistInvalidIds.length" class="gx-bb__tip gx-bb__tip--red">
              以下历史类目已失效：{{ strategyBlacklistInvalidIds.join('、') }}。确认后将从黑名单中移除。
              <el-button type="text" size="mini" @click="confirmRemoveInvalidBlacklistIds">确认移除</el-button>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer"><el-button @click="strategyFormShow = false">取消</el-button><el-button type="primary" :loading="strategySaving" :disabled="strategySaveDisabled" @click="saveStrategy">保存</el-button></span>
      </el-dialog>
    </el-dialog>

    <el-dialog title="批量设置盲盒策略" :visible.sync="batchStrategyShow" width="460px" append-to-body>
      <el-form size="mini" label-width="90px">
        <el-form-item label="已选店铺"><span>{{ selectedShopIds.length }} 家</span></el-form-item>
        <el-form-item label="开启中店铺"><span>{{ selectedEnabledShopCount }} 家</span></el-form-item>
        <el-form-item label="选择策略"><el-select v-model="batchStrategyId" :loading="strategyLoading" :disabled="strategyLoading" filterable placeholder="请选择策略" style="width:100%"><el-option v-for="item in strategyList" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item>
      </el-form>
      <p class="gx-bb__tip">确认后，已选店铺后续盲盒任务立即使用该策略。</p>
      <span slot="footer"><el-button @click="batchStrategyShow = false">取消</el-button><el-button type="primary" :loading="batchStrategySaving || strategyLoading" :disabled="strategyLoading || !batchStrategyId" @click="saveBatchStrategy">确认绑定</el-button></span>
    </el-dialog>

    <!-- ========== 抖店编辑弹窗 ========== -->
    <div v-if="editShow && editType === 'douyin' && currentShop.shop_id" class="gx-modal" @click.self="closeEdit">
      <div class="gx-modal-box gx-bb__modal-box--xl">
        <div class="gx-modal-head">
          <div class="gx-modal-head-title">
            <span class="gx-modal-title">编辑盲盒配置 - {{ currentShop.shop_name }}</span>
            <span class="gx-bb__tag gx-bb__tag--mi gx-bb__tag--danger">抖店</span>
          </div>
          <button class="gx-modal-close" @click="closeEdit">✕</button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <el-form size="mini" label-width="140px" label-position="left" class="gx-bb__form">
            <div v-if="shopStrategyDetailLoading" class="gx-bb__tip">正在加载当前盲盒策略配置...</div>
            <div v-if="shopStrategyDetailError" class="gx-bb__tip gx-bb__tip--red">
              {{ shopStrategyDetailError }} <el-button size="mini" type="text" @click="retryShopStrategyDetail">重试</el-button>
            </div>
            <div v-if="shopResourcesLoading" class="gx-bb__tip">正在加载店铺资源...</div>
            <div v-if="shopResourcesError" class="gx-bb__tip gx-bb__tip--red">
              {{ shopResourcesError }} <el-button size="mini" type="text" @click="retryShopResources">重试</el-button>
            </div>
            <el-form-item label="当前盲盒策略">
              <el-input :value="currentShop.blind_box_strategy ? currentShop.blind_box_strategy.name : '未绑定'" disabled class="w250"></el-input>
              <el-button size="mini" class="gx-bb__btn-soft-red" @click="openStrategyManager">前往策略管理</el-button>
            </el-form-item>
<!--            <el-form-item label="铺货限价">-->
<!--              <el-input-number v-model="currentShop.shop_limit_price" :controls="false" :min="0" :precision="2" disabled class="w250"></el-input-number>-->
<!--              <div class="gx-bb__tip gx-bb__tip&#45;&#45;red">不得输入小于0的数值，限价指的是铺货时，自动过滤价格低于限价的商品。</div>-->
<!--            </el-form-item>-->
            <el-form-item label="铺货限价">
              <span class="gx-bb__readonly-text">{{ shopLimitRangeText }}</span>
            </el-form-item>
            <el-form-item label="标题英文字母">
              <span class="gx-bb__readonly-text">{{ shopTitleLetterText }}</span>
            </el-form-item>
            <el-form-item label="上架策略">
              <el-select v-model="currentShop.strategies_id" class="w250" placeholder="请选择" disabled>
                <el-option v-for="item in strategiesList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item required>
              <template slot="label">
                <span>运费模板</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <el-select v-model="currentShop.shop_freight_template_id" class="w250" placeholder="请选择">
                <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name"
                           :value="String(item.id)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店铺商品来源">
              <el-select v-model="currentShop.shop_product_source" class="w250" placeholder="请选择" disabled>
                <!--                <el-option :value="1" label="系统商品"></el-option>-->
                <el-option :value="2" label="云商品库"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==2">
              <el-form-item label="商品sku替换状态">
                <el-select v-model="currentShop.shop_product_repository_skus" multiple clearable placeholder="请选择" style="width: 100%" disabled>
                  <el-option :value="1" label="上未替换"></el-option>
                  <el-option :value="2" label="上已替换"></el-option>
                  <el-option :value="3" label="上找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品sku标记状态">
                <el-select :key="'shop-sku-mark-' + shopEditRequestId" :value="displaySkuMarkStatuses" multiple clearable placeholder="请选择" style="width: 100%" disabled>
                  <el-option :value="1" label="未标记"></el-option>
                  <el-option :value="2" label="已标记"></el-option>
                  <el-option :value="3" label="找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主分组">
                <el-select :key="'shop-main-group-' + shopEditRequestId + '-' + cloudGroupListStatus" :value="displayMainGroupIds" multiple placeholder="不选择则不限制分组" clearable disabled style="width: 100%">
                  <el-option v-for="group in namedMainGroupOptions" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
                <div v-if="cloudGroupListStatus === 'error' && configuredMainGroupIds.length" class="gx-bb__tip gx-bb__tip--red">分组加载失败，暂不能显示已选分组</div>
                <div v-else-if="hasInvalidMainGroups" class="gx-bb__tip gx-bb__tip--red">分组已失效，请核对当前盲盒策略</div>
              </el-form-item>
              <el-form-item label="子分组" v-if="currentShop?.shop_product_repository_groups?.length">
                <el-select v-model="currentShop.shop_product_repository_child_groups" multiple placeholder="选择子分组" clearable disabled style="width: 100%">
                  <el-option v-for="group in cloudGroupChilder" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="抖店上货类目">
              <div class="gx-bb__category-summary">
                <span v-if="categorySummaryLoading">类目摘要加载中...</span>
                <span v-else-if="categorySummaryError" class="gx-bb__tip--red">{{ categorySummaryError }} <el-button type="text" size="mini" @click="loadShopCategorySummary()">重试</el-button></span>
                <template v-else>
                  <span>已选 {{ categorySummary.publish.total }} 项</span>
                  <el-button v-if="categorySummary.publish.total" size="mini" class="gx-bb__btn-soft-red" @click="openSelectedCategories('publish')">查看全部</el-button>
                  <span v-if="categoryPreviewText('publish')" class="gx-bb__category-preview">{{ categoryPreviewText('publish') }}</span>
                </template>
              </div>
              <p class="gx-bb__tip gx-bb__tip--red">铺货时，抖店预测商品类目与当前预设类目不一致，将会被拦截铺货。<span v-if="currentShop.shop_product_source==1">当前仅支持最多选择【20】个二级类目！</span></p>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <span>类目品牌</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <div class="gx-bb__category-summary">
                <span v-if="categorySummaryLoading || shopResourcesLoading">类目数量加载中...</span>
                <span v-else-if="categorySummaryError" class="gx-bb__tip--red">{{ categorySummaryError }} <el-button type="text" size="mini" @click="loadShopCategorySummary()">重试</el-button></span>
                <span v-else-if="shopResourcesError" class="gx-bb__tip--red">{{ shopResourcesError }} <el-button type="text" size="mini" @click="retryShopResources">重试</el-button></span>
                <template v-else>
                  <span>已选择 {{ brandCategoryCounts.selected }} 项，配置 {{ brandCategoryCounts.configured }} 项，剩余 {{ brandCategoryCounts.remaining }} 项未配置</span>
                  <el-button size="mini" class="gx-bb__btn-soft-red" :disabled="shopResourcesLoading || !!shopResourcesError" @click="openSelectedCategories('brand')">查看／编辑</el-button>
                  <el-button size="mini" class="gx-bb__btn-soft-red" :disabled="!shopStrategyId || shopStrategyDetailLoading || !!shopStrategyDetailError || categorySummaryLoading || !!categorySummaryError || shopResourcesLoading || !!shopResourcesError" @click="openBrandCandidates">添加类目品牌</el-button>
                </template>
              </div>
              <div class="gx-bb__tip gx-bb__tip--red">
                登录对应店铺，点击“<a href="https://fxg.jinritemai.com/ffa/grs-new/qualification/list" target="_blank">前往查看</a>”店铺类目品牌。仅需配置有品牌的类目，未配置默认使用“无品牌”进行铺货验证
              </div>
            </el-form-item>
            <el-form-item label="每日铺货额度">
              <el-input :value="formatQuantity(getDailyPublishQuota(currentShop))" disabled class="w250"></el-input>
              <div class="gx-bb__tip">按授权状态和本系统30天考核窗口计算；策略每日数量不再限制抖店。</div>
            </el-form-item>
            <el-form-item label="商品无Sku图拦截铺货">
<!--              <el-switch v-model="currentShop.is_sku_miss_off" :active-value="2" :inactive-value="1" size="small" disabled></el-switch>-->
              <span class="gx-bb__tag" :class="currentShop.is_sku_miss_off != 2 ? 'gx-bb__tag--success' : 'gx-bb__tag--warn'">{{ currentShop.is_sku_miss_off != 2 ? '未拦截' : '拦截中' }}</span>
            </el-form-item>
            <el-form-item label="店铺黑名单叶子类目">
              <div class="gx-bb__category-summary">
                <span v-if="categorySummaryLoading">类目摘要加载中...</span>
                <span v-else-if="categorySummaryError" class="gx-bb__tip--red">{{ categorySummaryError }} <el-button type="text" size="mini" @click="loadShopCategorySummary()">重试</el-button></span>
                <template v-else>
                  <span>已选 {{ categorySummary.blacklist.total }} 项</span>
                  <el-button v-if="categorySummary.blacklist.total" size="mini" class="gx-bb__btn-soft-red" @click="openSelectedCategories('blacklist')">查看全部</el-button>
                  <span v-if="categoryPreviewText('blacklist')" class="gx-bb__category-preview">{{ categoryPreviewText('blacklist') }}</span>

                </template>
              </div>
              <p class="gx-bb__tip gx-bb__tip--red">设置“不允许铺货”的最末级商品类目，商品类目预测时，会先从预测候选叶子类目中排除黑名单项，再返回可用预测结果</p>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==1">
              <div v-for="(item,index) in selSubCate" :key="index">
                <div style="margin-bottom: 6px;font-weight: 700;">{{item.label}}：</div>
                <div class="form-item" >
                  <el-input  v-model="item.search"  placeholder="输入不上关键词" size="small" style="width: 250px;">
                    <el-button slot="append" icon="el-icon-search" :loading="item.loading" @click="searchKeyword(index)"></el-button>
                  </el-input>
                  <el-select v-model="item.keyword" multiple :multiple-limit="10" placeholder="请选择不上关键词" size="small" clearable style="flex: 1">
                    <el-option v-for="(key,i) in item.keyword_arr" :label="key" :value="key" :key="i"></el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-form>
        </div>
        <div class="gx-modal-foot gx-modal-foot--bg">
          <button class="gx-modal-foot-btn" @click="closeEdit">关闭</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="sLoading || brandCategoryBatchLoading || shopStrategyDetailLoading || !!shopStrategyDetailError || shopResourcesLoading || !!shopResourcesError" @click="saveShopSettings">
            {{ sLoading ? '保存中...' : '保存设置' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ========== 类目品牌查看／编辑（抖店，全量 + 前端分页） ========== -->
    <el-dialog title="类目品牌查看／编辑" :visible.sync="brandCategoryShow" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="gx-bb__category-dialog">
        <div class="gx-bb__category-toolbar">
          <el-input v-model.trim="brandCategoryKeyword" size="mini" clearable placeholder="搜索类目名称或 ID" @keyup.enter.native="searchBrandCategories" @clear="searchBrandCategories" />
          <el-button size="mini" @click="searchBrandCategories">搜索</el-button>
          <el-select v-model="brandCategoryFilter.one" size="mini" filterable clearable placeholder="一级类目" @change="onBrandCategoryOneChange">
            <el-option v-for="item in brandCategoryLevelOptions.one" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="brandCategoryFilter.two" size="mini" filterable clearable placeholder="二级类目" :disabled="!brandCategoryFilter.one" @change="onBrandCategoryTwoChange">
            <el-option v-for="item in brandCategoryLevelOptions.two" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="brandCategoryFilter.three" size="mini" filterable clearable placeholder="三级类目" :disabled="!brandCategoryFilter.two" @change="onBrandCategoryFilterChange">
            <el-option v-for="item in brandCategoryLevelOptions.three" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="brandCategoryFilter.config" size="mini" clearable placeholder="类目配置" @change="onBrandCategoryFilterChange">
            <el-option label="未配置" value="unset" />
            <el-option label="已配置" value="set" />
          </el-select>
        </div>
        <div class="gx-bb__dialog-batch-bar">
          <span class="gx-bb__batch-count">
            已选 {{ brandCategorySelection.length }} 项
            <template v-if="brandCategoryPendingCount || brandCategoryRemovedCount">（本次新增 {{ brandCategoryPendingCount }} 项 · 本次移除 {{ brandCategoryRemovedCount }} 项，保存后生效）</template>
          </span>
          <el-button size="mini" :loading="brandCategoryBatchLoading && brandCategoryBatchMode === 'new'" :disabled="brandCategoryBatchLoading || brandCategoryLoading || !!brandCategoryError || !brandCategoryPageNewUnconfiguredRows.length" @click="readCurrentPageNewBrands">读取本页新增类目品牌</el-button>
          <el-button size="mini" :loading="brandCategoryBatchLoading && brandCategoryBatchMode === 'saved'" :disabled="brandCategoryBatchLoading || brandCategoryLoading || !!brandCategoryError || !brandCategoryPageSavedRows.length" @click="readCurrentPageSavedBrands">读取本页已存类目品牌</el-button>
          <el-button size="mini" :disabled="!brandCategorySelection.length" @click="removeSelectedBrandCategories">一键移除所选类目</el-button>
          <el-button size="mini" :disabled="!brandCategorySelection.length" @click="clearBrandCategorySelection">清空选中</el-button>
          <el-button size="mini" type="primary" :disabled="!shopStrategyId || shopStrategyDetailLoading || !!shopStrategyDetailError || categorySummaryLoading || !!categorySummaryError" @click="openBrandCandidates">添加类目品牌</el-button>
        </div>
        <div v-if="brandCategoryError" class="gx-bb__tip gx-bb__tip--red">{{ brandCategoryError }} <el-button type="text" size="mini" @click="loadBrandCategoryRows">重试</el-button></div>
        <el-table v-loading="brandCategoryLoading" ref="brandCategoryTable" :data="brandCategoryPagedRows" size="mini" border row-key="id" max-height="380" @selection-change="onBrandCategorySelectionChange">
          <el-table-column type="selection" width="46" reserve-selection />
          <el-table-column prop="id" label="叶子类目ID" width="140" />
          <el-table-column label="类目path" min-width="220">
            <template #default="{ row }">
              <span>{{ row.path_name || row.id }}</span>
              <span v-if="isBrandCategoryPending(row)" class="gx-bb__tag gx-bb__tag--warn gx-bb__category-tag">本次新增</span>
              <span v-if="!row.valid" class="gx-bb__tag gx-bb__tag--danger gx-bb__category-tag">{{ row.outside_strategy ? '策略外历史类目' : '失效类目' }}</span>
              <span v-if="brandCategoryBatchLoading && brandCategoryBatchActiveId === String(row.id)" class="gx-bb__tag gx-bb__tag--info gx-bb__category-tag" role="status">正在读取品牌</span>
            </template>
          </el-table-column>
          <el-table-column label="选择品牌" width="240">
            <template #default="{ row }">
              <span v-if="brandRemoved[String(row.id)]" class="gx-bb__tip">已移除，保存后生效</span>
              <el-select v-else :value="selectedBrandValue(row)" class="gx-bb__brand-select" size="mini" filterable placeholder="请选择品牌" :loading="!!brandOptionsLoading[row.id]" @focus="loadBrandOptions(row.id)" @change="setSelectedBrand(row, $event)">
                <el-option v-for="brand in brandOptionsFor(row)" :key="brand.brand_id" :label="brand.name_cn || brand.brand_name" :value="String(brand.brand_id)" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template #default="{ row }">
              <el-button size="mini" type="text" @click="removeBrandCategory(row)">{{ brandRemoved[String(row.id)] ? '撤销移除' : '移除' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!brandCategoryLoading && !brandCategoryFilteredRows.length" class="gx-bb__tip">暂无已选类目</div>
        <div class="gx-bb__category-pager">
          <div class="turn_page custom-page-wrap gx-bb__category-pager-controls">
            <el-pagination :key="brandCategoryBatchLoading ? 'reading' : 'ready'" :total="brandCategoryFilteredRows.length" :current-page="brandCategoryPage" :page-size="brandCategoryPageSize" :page-sizes="[20, 50, 100, 200, 500, 1000]" :disabled="brandCategoryBatchLoading" layout="total, sizes, prev, pager, next, jumper" prev-text="‹" next-text="›" @update:currentPage="onBrandCategoryPageChange" @update:pageSize="onBrandCategoryPageSizeChange" />
            <div v-if="brandCategoryBatchLoading" class="gx-bb__category-pager-blocker" role="button" tabindex="0" aria-label="读取类目品牌期间暂不可调整分页" @click.stop.prevent="notifyBlockedBrandCategoryPagination" @keydown.enter.stop.prevent="notifyBlockedBrandCategoryPagination" />
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="selectedCategoryKind === 'publish' ? '已选抖店上货类目' : '已选店铺黑名单叶子类目'"
               :visible.sync="selectedCategoryShow" append-to-body width="760px" :close-on-click-modal="false">
      <div class="gx-bb__category-dialog">
        <div class="gx-bb__category-toolbar">
          <el-select v-model="selectedCategoryFilter.one" size="mini" filterable clearable placeholder="一级类目" @change="onSelectedCategoryOneChange">
            <el-option v-for="item in selectedCategoryLevelOptions.one" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="selectedCategoryFilter.two" size="mini" filterable clearable placeholder="二级类目" :disabled="!selectedCategoryFilter.one" @change="onSelectedCategoryTwoChange">
            <el-option v-for="item in selectedCategoryLevelOptions.two" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-if="selectedCategoryKind === 'blacklist'" v-model="selectedCategoryFilter.three" size="mini" filterable clearable placeholder="三级类目" :disabled="!selectedCategoryFilter.two" @change="onSelectedCategoryFilterChange">
            <el-option v-for="item in selectedCategoryLevelOptions.three" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
        <div v-if="selectedCategoryLoading" class="gx-bb__tip">正在加载已选类目...</div>
        <div v-else-if="selectedCategoryError" class="gx-bb__tip gx-bb__tip--red">{{ selectedCategoryError }} <el-button size="mini" type="text" @click="loadSelectedCategories">重试</el-button></div>
        <template v-else>
          <el-table :data="selectedCategoryPagedRows" size="mini" border row-key="id" max-height="380">
            <el-table-column prop="id" :label="selectedCategoryKind === 'publish' ? '二级类目ID' : '叶子类目ID'" width="140" />
            <el-table-column label="类目path" min-width="220">
              <template #default="{ row }">
                <span>{{ row.path_name || row.id }}</span>
                <span v-if="!row.valid" class="gx-bb__tag gx-bb__tag--danger gx-bb__category-tag">失效类目</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="!selectedCategoryFilteredRows.length" class="gx-bb__tip">暂无已选类目</div>
          <div class="gx-bb__category-pager">
            <div class="turn_page custom-page-wrap gx-bb__category-pager-controls">
              <el-pagination :total="selectedCategoryFilteredRows.length" :current-page="selectedCategoryPage" :page-size="selectedCategoryPageSize" :page-sizes="[20, 50, 100, 200, 500, 1000]" layout="total, sizes, prev, pager, next, jumper" prev-text="‹" next-text="›" @update:currentPage="onSelectedCategoryPageChange" @update:pageSize="onSelectedCategoryPageSizeChange" />
            </div>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- ========== 添加类目品牌（抖店候选类目） ========== -->
    <el-dialog
      :visible.sync="brandCandidatesShow"
      append-to-body
      width="900px"
      custom-class="custom-el-wrapper gx-bb__candidates-dialog"
      destroy-on-close
      :close-on-click-modal="false">
      <template #title>
        <span class="el-dialog__title">添加类目品牌</span>
        <span class="gx-bb__tag gx-bb__tag--mi gx-bb__tag--danger gx-bb__dialog-title-tag">抖店</span>
      </template>
      <div class="gx-bb__category-dialog">
        <p class="gx-bb__tip">仅可添加当前盲盒策略已选抖店上货二级类目下的叶子类目。</p>
        <div class="gx-bb__category-toolbar">
          <el-input v-model.trim="brandCandidatesKeyword" size="mini" clearable placeholder="搜索类目名称或 ID" @keyup.enter.native="searchBrandCandidates" @clear="searchBrandCandidates" />
          <el-button size="mini" @click="searchBrandCandidates">搜索</el-button>
          <el-select v-model="brandCandidateFilter.one" size="mini" filterable clearable placeholder="一级类目" :loading="brandCandidateOptionsLoading.one" @change="onBrandCandidateOneChange">
            <el-option v-for="item in brandCandidateOptions.one" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="brandCandidateFilter.two" size="mini" filterable clearable placeholder="二级类目" :disabled="!brandCandidateFilter.one" :loading="brandCandidateOptionsLoading.two" @change="onBrandCandidateTwoChange">
            <el-option v-for="item in brandCandidateOptions.two" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="brandCandidateFilter.three" size="mini" filterable clearable placeholder="三级类目" :disabled="!brandCandidateFilter.two" :loading="brandCandidateOptionsLoading.three" @change="onBrandCandidateThreeChange">
            <el-option v-for="item in brandCandidateOptions.three" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
        <div class="gx-bb__dialog-batch-bar">
          <span class="gx-bb__batch-count">已选 {{ brandCandidatesSelected.length }} 项</span>
          <el-button size="mini" type="primary" :loading="brandCandidatesAdding" :disabled="!brandCandidatesSelected.length || brandCandidatesLoading || !!brandCandidatesError || brandCandidatesAdding || !shopPublishCategoryIds.length" @click="batchAddBrandCategories">批量添加</el-button>
          <el-button size="mini" :disabled="!brandCandidatesSelected.length" @click="clearBrandCandidatesSelection">清空选中</el-button>
        </div>
        <div v-if="brandCandidateOptionsError" class="gx-bb__tip gx-bb__tip--red">
          {{ brandCandidateOptionsError }} <el-button type="text" size="mini" @click="retryBrandCandidateOptions">重试</el-button>
        </div>
        <div v-if="brandCandidatesError" class="gx-bb__tip gx-bb__tip--red">{{ brandCandidatesError }} <el-button type="text" size="mini" @click="loadBrandCandidates(brandCandidatesPage)">重试</el-button></div>
        <el-table v-loading="brandCandidatesLoading" ref="brandCandidatesTable" :data="brandCandidatesRows" size="mini" border row-key="id" max-height="380" @selection-change="onBrandCandidatesSelectionChange">
          <el-table-column type="selection" width="46" reserve-selection :selectable="isBrandCandidateSelectable" />
          <el-table-column prop="id" label="叶子类目ID" width="150" />
          <el-table-column label="类目path">
            <template #default="{ row }">
              <span>{{ row.path_name || row.id }}</span>
              <span v-if="isBrandCategorySelected(row.id)" class="gx-bb__tag gx-bb__tag--success gx-bb__category-tag">已配置</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!brandCandidatesLoading && !brandCandidatesError && !brandCandidatesRows.length" class="gx-bb__tip">{{ !shopPublishCategoryIds.length ? '当前策略未选择抖店上货类目，无法添加类目品牌' : '已选上货类目下没有符合当前筛选条件的叶子类目' }}</div>
        <div class="gx-bb__category-pager">
          <Pagination :total="brandCandidatesTotal" :page.sync="brandCandidatesPage" :limit.sync="brandCandidatesPageSize" :page-sizes="[20, 50, 100, 200, 500, 1000]" layout="total, sizes, prev, pager, next, jumper" @pagination="loadBrandCandidates(brandCandidatesPage)" />
        </div>
      </div>
      <template #footer>
        <button class="gx-modal-foot-btn" @click="closeBrandCandidates">关闭</button>
      </template>
    </el-dialog>

    <!-- ========== 微信编辑弹窗 ========== -->
    <div v-if="editShow && editType === 'wechat' && currentShop.shop_id" class="gx-modal" @click.self="closeEdit">
      <div class="gx-modal-box gx-bb__modal-box--xl">
        <div class="gx-modal-head">
          <div class="gx-modal-head-title" >
            <span class="gx-modal-title">编辑微信盲盒配置 - {{ currentShop.shop_name }}</span>
            <span class="gx-bb__tag gx-bb__tag--mi gx-bb__tag--success">微信小店</span>
          </div>
          <button class="gx-modal-close" @click="closeEdit">✕</button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <div class="gx-bb__section-title">基础设置</div>
          <div v-if="wechatStrategyLoading" class="gx-bb__tip">正在加载当前盲盒策略…</div>
          <div v-if="wechatStrategyError" class="gx-bb__tip gx-bb__tip--red">{{ wechatStrategyError }} <el-button type="text" size="mini" @click="retryWechatStrategy">重试</el-button></div>
          <div v-if="wechatResourcesLoading" class="gx-bb__tip">正在加载店铺资源…</div>
          <div v-if="wechatResourcesError" class="gx-bb__tip gx-bb__tip--red">{{ wechatResourcesError }} <el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
          <div v-if="!shopStrategyId" class="gx-bb__tip gx-bb__tip--red">请先为店铺绑定盲盒策略，再保存店铺资源。</div>
          <el-form size="mini" label-width="120px" label-position="left" class="gx-bb__form">
            <el-form-item label="当前盲盒策略">
              <el-input :value="currentShop.blind_box_strategy ? currentShop.blind_box_strategy.name : '未绑定'" disabled class="w250"></el-input>
              <el-button size="mini" class="gx-bb__btn-soft-red" @click="openStrategyManager">前往策略管理</el-button></el-form-item>
<!--            <el-form-item label="铺货限价" prop="shop_limit_price">-->
<!--              <el-input-number v-model="wForm.shop_limit_price" :controls="false" :min="0" :precision="2" disabled class="w250"></el-input-number>-->
<!--              <div class="gx-bb__tip gx-bb__tip&#45;&#45;red">限价指的是铺货时，自动过滤价格低于限价的商品</div>-->
<!--            </el-form-item>-->
            <el-form-item label="铺货限价">
              <span class="gx-bb__readonly-text">{{ wechatLimitRangeText }}</span>
            </el-form-item>
            <el-form-item label="标题英文字母">
              <span class="gx-bb__readonly-text">{{ wechatTitleLetterText }}</span>
            </el-form-item>
            <el-form-item label="上架策略" prop="strategies_id">
              <el-select v-model="wForm.strategies_id" class="w250" placeholder="请选择" disabled>
                <el-option v-for="item in strategiesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item required>
              <template slot="label">
                <span>运费模板</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <el-select v-model="wForm.freight_template_id" class="w250" placeholder="请选择">
                <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name" :value="String(item.id)"></el-option>
              </el-select>
              <div v-if="wechatFreightTemplateInvalid" class="gx-bb__tip gx-bb__tip--red">已保存的运费模板不可用，请重新选择。<el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
              <div v-else-if="!wechatResourcesLoading && !wechatResourcesError && !freightTemplate.length" class="gx-bb__tip gx-bb__tip--red">暂无可用运费模板 <el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <span>运费险</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <el-switch v-model="wForm.freight_insurance" ></el-switch>
            </el-form-item>
            <el-form-item label="店铺商品来源">
              <el-input value="云商品库" class="w250" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品sku状态">
              <el-select v-model="wForm.shop_product_repository_skus" multiple placeholder="请选择" style="width: 100%" disabled>
                <el-option v-for="item in skuStatusOptions" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品分组">
              <el-select v-model="wForm.shop_product_repository_groups" multiple placeholder="不选择则不限制分组" style="width: 100%" disabled>
                <el-option v-for="group in cloudGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品子分组">
              <el-select v-model="wForm.shop_product_repository_child_groups" multiple placeholder="不选择则不限制子分组" style="width: 100%" disabled>
                <el-option v-for="group in wechatChildGroups" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每日铺货数量" prop="daily_num">
              <el-input :value="wForm.daily_num == null ? '' : wForm.daily_num" disabled class="w250"></el-input>
            </el-form-item>
            <el-form-item prop="return_address_id">
              <template slot="label">
                <span>售后地址</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <el-select v-model="wForm.return_address_id" class="w250" placeholder="请选择售后地址">
                <el-option v-for="item in wReturnAddressList" :key="item.address_id" :label="formatAddress(item)" :value="String(item.address_id)"></el-option>
              </el-select>
              <div v-if="wechatReturnAddressInvalid" class="gx-bb__tip gx-bb__tip--red">已保存的售后地址不可用，请重新选择。<el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
              <div v-else-if="!wechatResourcesLoading && !wechatResourcesError && !wReturnAddressList.length" class="gx-bb__tip gx-bb__tip--red">暂无可用售后地址 <el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
            </el-form-item>
          </el-form>
          <div class="gx-bb__section-title">分类设置</div>
          <div class="gx-bb__tip gx-bb__tip--red" style="margin: 0 0 10px;">需要选择可以正常上货的分类，需要申请类目权限和缴纳对应的保证金，未缴纳保证金将铺货失败！</div>
          <div v-if="wechatCategoryLoading" class="gx-bb__tip">正在加载微信店铺授权类目…</div>
          <div v-if="wechatCategoryError" class="gx-bb__tip gx-bb__tip--red">{{ wechatCategoryError }} <el-button type="text" size="mini" @click="retryWechatCategories">重试</el-button></div>
          <div v-if="wechatMissingCategoryIds.length" class="gx-bb__tip gx-bb__tip--red">当前店铺未授权或已失效的策略二级类目：{{ wechatMissingCategoryIds.join('、') }}。请核对策略和店铺类目权限。</div>
          <el-form size="mini" label-width="140px" label-position="left" class="gx-bb__form">
            <el-form-item label="微信二级分类">
              <div v-if="wechatStrategyLoaded && wechatCategoriesLoaded" class="gx-bb__category-summary">
                <span>已选 {{ wechatSelectedCategoryRows.length }} 项</span>
                <el-button v-if="wechatSelectedCategoryRows.length" size="mini" class="gx-bb__btn-soft-red" @click="openWechatCategoryDialog">查看全部</el-button>
                <span v-if="wechatCategoryPreview" class="gx-bb__category-preview">{{ wechatCategoryPreview }}</span>
              </div>
              <div class="gx-bb__tip gx-bb__tip--red">铺货时，微信预测前三个类目的二级类目与当前预设类目不一致，将会被拦截铺货。</div>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <span>类目品牌</span>
                <span class="gx-bb__tag gx-bb__tag--editable">可编辑</span>
              </template>
              <div v-if="wechatStaleBrandKeys.length" class="gx-bb__tip gx-bb__tip--red">有 {{ wechatStaleBrandKeys.length }} 条历史品牌映射不属于当前策略，保存时需确认清理。</div>
              <div v-if="wechatStrategyLoaded && wechatResourcesLoaded && wechatCategoriesLoaded" class="gx-bb__category-summary">
                <span>已选择 {{ wechatBrandCounts.selected }} 项，配置 {{ wechatBrandCounts.configured }} 项，剩余 {{ wechatBrandCounts.remaining }} 项未配置</span>
                <el-button size="mini" class="gx-bb__btn-soft-red" @click="openWechatBrandDialog">查看／编辑</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot gx-modal-foot--bg">
          <button class="gx-bb__btn" @click="closeEdit">取消</button>
          <button class="gx-bb__btn gx-bb__btn--primary" :disabled="wechatSaveDisabled" @click="saveWechatSettings">
            {{ sLoading ? '保存中...' : '保存设置' }}
          </button>
        </div>
      </div>
    </div>
    <el-dialog title="微信二级分类" :visible.sync="wechatCategoryDialogShow" append-to-body width="760px" :close-on-click-modal="false">
      <div class="gx-bb__category-dialog">
        <div class="gx-bb__category-toolbar">
          <el-select v-model="wechatCategoryFilter.one" size="mini" filterable clearable placeholder="一级类目" @change="onWechatCategoryOneChange">
            <el-option v-for="item in wechatCategoryLevelOptions.one" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="wechatCategoryFilter.two" size="mini" filterable clearable placeholder="二级类目" :disabled="!wechatCategoryFilter.one" @change="wechatCategoryPage = 1">
            <el-option v-for="item in wechatCategoryLevelOptions.two" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
        <el-table :data="wechatCategoryPagedRows" size="mini" border row-key="id" max-height="380">
          <el-table-column prop="id" label="二级类目ID" width="140" />
          <el-table-column label="类目path" min-width="220">
            <template #default="{ row }">
              <span>{{ row.path_name }}</span>
              <span v-if="!row.valid" class="gx-bb__tag gx-bb__tag--danger gx-bb__category-tag">失效类目</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!wechatCategoryFilteredRows.length" class="gx-bb__tip">暂无已选类目</div>
        <div class="gx-bb__category-pager"><div class="turn_page custom-page-wrap gx-bb__category-pager-controls">
          <el-pagination :total="wechatCategoryFilteredRows.length" :current-page="wechatCategoryPage" :page-size="wechatCategoryPageSize" :page-sizes="[20, 50, 100, 200, 500, 1000]" layout="total, sizes, prev, pager, next, jumper" prev-text="‹" next-text="›" @update:currentPage="wechatCategoryPage = $event" @update:pageSize="onWechatCategoryPageSizeChange" />
        </div></div>
      </div>
    </el-dialog>
    <el-dialog title="类目品牌查看／编辑" :visible.sync="wechatBrandDialogShow" append-to-body width="860px" :close-on-click-modal="false">
      <div class="gx-bb__category-dialog">
        <div v-if="!wShopBrandList.length" class="gx-bb__tip gx-bb__tip--red">暂无可选品牌 <el-button type="text" size="mini" @click="retryWechatResources">重试</el-button></div>
        <div class="gx-bb__category-toolbar">
          <el-input v-model.trim="wechatBrandKeyword" size="mini" clearable placeholder="搜索类目名称或 ID" @keyup.enter.native="wechatBrandPage = 1" @clear="wechatBrandPage = 1" />
          <el-button size="mini" @click="wechatBrandPage = 1">搜索</el-button>
          <el-select v-model="wechatBrandFilter.one" size="mini" filterable clearable placeholder="一级类目" @change="onWechatBrandOneChange">
            <el-option v-for="item in wechatBrandLevelOptions.one" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="wechatBrandFilter.two" size="mini" filterable clearable placeholder="二级类目" :disabled="!wechatBrandFilter.one" @change="wechatBrandPage = 1">
            <el-option v-for="item in wechatBrandLevelOptions.two" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="wechatBrandFilter.config" size="mini" clearable placeholder="类目配置" @change="wechatBrandPage = 1">
            <el-option label="未配置" value="unset" /><el-option label="已配置" value="set" />
          </el-select>
        </div>
        <el-table :data="wechatBrandPagedRows" size="mini" border row-key="id" max-height="380">
          <el-table-column prop="id" label="二级类目ID" width="140" />
          <el-table-column label="类目path" min-width="220">
            <template #default="{ row }">
              <span>{{ row.path_name }}</span>
              <span v-if="!row.valid" class="gx-bb__tag gx-bb__tag--danger gx-bb__category-tag">失效类目</span>
            </template>
          </el-table-column>
          <el-table-column label="选择品牌" width="240">
            <template #default="{ row }">
              <span v-if="!row.valid">{{ wechatBrandName(row.brand) || '未配置' }}</span>
              <el-select v-else :value="wechatBrandValue(row.brand)" class="gx-bb__brand-select" size="mini" filterable clearable placeholder="请选择品牌" @change="setWechatCategoryBrand(row, $event)">
                <el-option v-for="brand in wShopBrandList" :key="brand.brand_id" :label="brand.name_cn || brand.brand_name" :value="String(brand.brand_id)" />
                <el-option v-if="wechatBrandValue(row.brand) && !wechatBrandInShopList(row.brand)" :key="`saved-${row.brand.brand_id}`" :label="wechatBrandName(row.brand)" :value="String(row.brand.brand_id)" disabled />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!wechatBrandFilteredRows.length" class="gx-bb__tip">暂无已选类目</div>
        <div class="gx-bb__category-pager"><div class="turn_page custom-page-wrap gx-bb__category-pager-controls">
          <el-pagination :total="wechatBrandFilteredRows.length" :current-page="wechatBrandPage" :page-size="wechatBrandPageSize" :page-sizes="[20, 50, 100, 200, 500, 1000]" layout="total, sizes, prev, pager, next, jumper" prev-text="‹" next-text="›" @update:currentPage="wechatBrandPage = $event" @update:pageSize="onWechatBrandPageSizeChange" />
        </div></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LowSalesAuthorizationNotice from '@/components/LowSalesAuthorizationNotice.vue'
import { mapActions, mapState } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import Pagination from "@/components/newUi/Pagination.vue";
import common from '../../assets/js/utils/common'
import {
  blindBoxStrategyList,
  createBlindBoxStrategy,
  updateBlindBoxStrategy,
  bindBlindBoxStrategy,
  deleteBlindBoxStrategy,
  saveBlindBoxResources,
  blindBoxStrategyCategoryTree,
  blindBoxStrategyBlacklistCategoryTree,
  getBlindBoxStrategy,
  getBlindBoxShopCategorySummary,
  getBlindBoxShopSelectedCategories,
  getBlindBoxShopBrandCandidates,
  getBlindBoxShopBrandCandidateCategories,
  getBrandList as getShopBrandList,
  blindBoxDetail,
  cloudProductGroups,
  wechatCategoryList,
  unbindBlindBoxStrategy,
} from '../../api/main/ucenter'

export default {
  name: 'NewBlindBoxPage',
  components: {Pagination, MultiSelect, GxLoading, PageSizeSelect },
  mixins: [gxLoading],
  data() {
    return {
      platforms: [
        { value: 1, label: '抖店' },
        { value: 7, label: '微店' }
      ],
      searchData: { shop_type: 1, group_ids: [], shop_name: '', shop_name_keyword: '', daily_status: '', low_sales: '', blind_box_strategy: '' },
      groupList: [],
      shopList: [],
      list: [],
      pageData: { limit: 50, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
      is_host: true,
      skuStatusOptions: [
        { id: 1, name: '上未替换' },
        { id: 2, name: '上已替换' },
        { id: 3, name: '上找不到' }
      ],
      // 编辑
      editShow: false,
      editType: 'douyin',
      currentShop: {},
      shopEditRequestId: 0,
      shopStrategyId: null,
      shopStrategyConfig: null,
      shopStrategyDetailLoading: false,
      shopStrategyDetailError: '',
      shopResourcesLoading: false,
      shopResourcesError: '',
      categorySummaryLoading: false,
      categorySummaryError: '',
      categorySummary: { publish: { total: 0, preview: [] }, blacklist: { total: 0, preview: [] }, brand: { total: 0, preview: [] } },
      selectedCategoryShow: false,
      selectedCategoryKind: 'publish',
      selectedCategoryFilter: { one: '', two: '', three: '' },
      selectedCategoryPage: 1,
      selectedCategoryPageSize: 50,
      selectedCategoryRows: [],
      selectedCategoryLoading: false,
      selectedCategoryError: '',
      selectedCategoryRequestId: 0,
      brandCandidatesShow: false,
      brandCandidatesKeyword: '',
      brandCandidatesPage: 1,
      brandCandidatesTotal: 0,
      brandCandidatesRows: [],
      brandCandidatesLoading: false,
      brandCandidatesError: '',
      brandCandidatesRequestId: 0,
      brandCandidatesAdding: false,
      brandCandidatesAddRequestId: 0,
      brandCandidatesSelected: [],
      shopPublishCategoryIds: [],
      brandCandidatesPageSize: 50,
      brandCandidateFilter: { one: '', two: '', three: '' },
      brandCandidateOptions: { one: [], two: [], three: [] },
      brandCandidateOptionsLoading: { one: false, two: false, three: false },
      brandCandidateOptionsRequestId: { one: 0, two: 0, three: 0 },
      brandCandidateOptionsError: '',
      brandCandidateOptionsErrorLevel: 0,
      brandCategoryShow: false,
      brandCategoryLoading: false,
      brandCategoryError: '',
      brandCategoryRequestId: 0,
      brandCategoryRows: [],
      brandCategoryKeyword: '',
      brandCategoryFilter: { one: '', two: '', three: '', config: '' },
      brandCategorySelection: [],
      brandCategoryPage: 1,
      brandCategoryPageSize: 50,
      brandCategoryBatchLoading: false,
      brandCategoryBatchMode: '',
      brandCategoryBatchActiveId: '',
      brandCategoryBatchRequestId: 0,
      brandAdded: {},
      brandRemoved: {},
      brandEdits: {},
      brandOptions: {},
      brandOptionsLoading: {},
      shopEditSource: null,
      strategiesList: [],
      listingStrategies: [],
      strategyShow: false,
      strategyFormShow: false,
      strategySaving: false,
      strategyList: [],
      strategyLoading: false,
      strategyLoadedPlatform: null,
      strategyForm: this.defaultStrategyForm(),
      strategyGroupList: [],
      strategyGroupStatus: 'idle',
      strategyGroupRequestId: 0,
      strategyChildGroups: [],
      strategyChildGroupStatus: 'idle',
      strategyChildGroupRequestId: 0,
      strategyCategoryTree: [],
      strategyCategoryIds: [],
      strategyWechatCategoryPaths: [],
      strategyCategoryLoading: false,
      strategyCategoryLoaded: false,
      strategyCategoryError: '',
      strategyCategoryRequestId: 0,
      strategyCategoryInvalidIds: [],
      strategyCategoryProps: { multiple: true, value: 'category_id', label: 'category_name', children: 'sub_category', emitPath: false, checkStrictly: false },
      strategyWechatCategoryProps: { multiple: true, value: 'category_id', label: 'category_name', children: 'sub_category', leaf: 'is_leaf', emitPath: true, checkStrictly: false },
      strategyBlacklistCategoryTree: [],
      strategyBlacklistCategoryPaths: [],
      strategyBlacklistCategoryLoading: false,
      strategyBlacklistCategoryLoaded: false,
      strategyBlacklistCategoryError: false,
      strategyBlacklistCategoryRequestId: 0,
      strategyBlacklistInvalidIds: [],
      strategyBlacklistCategoryProps: { multiple: true, value: 'category_id', label: 'category_name', children: 'sub_category', emitPath: true, checkStrictly: false },
      selectedShops: {},
      batchStrategyShow: false,
      batchStrategySaving: false,
      batchStrategyId: null,
      freightTemplate: [],
      maxAutoNum: 0,
      defaultNum: 0,
      defaultRatio: 0,
      sLoading: false,
      // 抖店分类/品牌
      cateList: [],
      selCate: [],
      selCateOld: [],
      cateRandom: Math.random(),
      expandedL1: {},
      isIndeterminate:false,
      cateSubAllChecked:false,
      selCateSubOptions: [],
      selCateSub: [],
      subCateBrand: {},
      brandKeyValues_def: {},
      removeCateIds:[],
      brandRandom:Math.random(),
      brandLoading:false,
      brandObjCache: {},
      brandListLoading: {},
      selSubCate: [],
      cloudGroupList: [],
      cloudGroupListStatus: 'idle',
      cloudGroupListRequestId: 0,
      cloudGroupChilder: [],
      // 微信
      wForm: {
        shop_limit_price: 0, strategies_id: '', freight_template_id: '', freight_insurance: false,
        shop_product_repository_skus: [], shop_product_repository_groups: [], shop_product_repository_child_groups: [], daily_num: 0, return_address_id: ''
      },
      wechatStrategyLoading: false,
      wechatStrategyError: '',
      wechatResourcesLoading: false,
      wechatResourcesError: '',
      wechatCategoryLoading: false,
      wechatCategoryError: '',
      wechatEffectiveCategoryIds: [],
      wechatMissingCategoryIds: [],
      wechatStaleBrandKeys: [],
      wechatBrandSnapshot: {},
      wechatChildGroups: [],
      wechatResourcesLoaded: false,
      wechatStrategyLoaded: false,
      wechatStrategyConfig: null,
      wechatCategoriesLoaded: false,
      wCateList: [],
      wCateTableData: [],
      wSelectedCateIds: [],
      wSelectedCateList: [],
      wShopBrandList: [],
      wReturnAddressList: [],
      wechatCategoryDialogShow: false,
      wechatCategoryFilter: { one: '', two: '' },
      wechatCategoryPage: 1,
      wechatCategoryPageSize: 50,
      wechatBrandDialogShow: false,
      wechatBrandKeyword: '',
      wechatBrandFilter: { one: '', two: '', config: '' },
      wechatBrandPage: 1,
      wechatBrandPageSize: 50,
      leafToSecondCateMap: {},
      expandedW: {},
      wCateCascaderProps: {
        multiple: true,
        value: 'category_id',
        label: 'category_name',
        children: 'sub_category',
        leaf: 'is_leaf',
        emitPath: true,
        checkStrictly: false
      },

      leafCateList:[],//店铺类目黑名单
      selLeafCate:[],
      unauthorized_quantity:0,//删除低效品授权未开启
      authorized_quantity:50,//删除低效品授权已开启
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    }),
    displaySkuMarkStatuses() {
      return this.normalizeSkuMarkStatuses(this.currentShop.shop_product_repository_skus_mark)
    },
    configuredMainGroupIds() {
      return Array.isArray(this.currentShop.shop_product_repository_groups)
        ? this.currentShop.shop_product_repository_groups : []
    },
    namedMainGroupOptions() {
      return this.cloudGroupList.filter(group => group && typeof group.name === 'string' && group.name.trim())
    },
    displayMainGroupIds() {
      if (this.cloudGroupListStatus !== 'success') return []
      const selected = new Set(this.configuredMainGroupIds.map(id => String(id)))
      return this.namedMainGroupOptions.filter(group => selected.has(String(group.id))).map(group => group.id)
    },
    hasInvalidMainGroups() {
      if (this.cloudGroupListStatus !== 'success') return false
      const available = new Set(this.namedMainGroupOptions.map(group => String(group.id)))
      return this.configuredMainGroupIds.some(id => !available.has(String(id)))
    },
    missingStrategyGroupNames() {
      if (this.strategyChildGroupStatus !== 'success') return []
      const selectedChildren = new Set(this.strategyForm.config.shop_product_repository_child_groups.map(id => String(id)))
      const coveredParents = new Set(this.strategyChildGroups
        .filter(child => selectedChildren.has(String(child.id)))
        .map(child => String(child.parent_id)))
      return this.strategyForm.config.shop_product_repository_groups
        .filter(id => !coveredParents.has(String(id)))
        .map(id => this.strategyGroupList.find(group => String(group.id) === String(id))?.name)
        .filter(Boolean)
    },
    invalidStrategyMainGroupIds() {
      if (this.strategyGroupStatus !== 'success') return []
      const available = new Set(this.strategyGroupList.map(group => String(group.id)))
      return this.strategyForm.config.shop_product_repository_groups.filter(id => !available.has(String(id)))
    },
    zeroProductStrategyMainGroupNames() {
      if (this.strategyGroupStatus !== 'success') return []
      const selected = new Set(this.strategyForm.config.shop_product_repository_groups.map(id => String(id)))
      return this.strategyGroupList
        .filter(group => selected.has(String(group.id)) && this.isZeroStrategyProductCount(group))
        .map(group => this.strategyMainGroupLabel(group))
    },
    zeroProductStrategyChildGroupNames() {
      if (this.strategyChildGroupStatus !== 'success') return []
      const selected = new Set(this.strategyForm.config.shop_product_repository_child_groups.map(id => String(id)))
      return this.strategyChildGroups
        .filter(group => selected.has(String(group.id)) && this.isZeroStrategyProductCount(group))
        .map(group => this.strategyChildGroupLabel(group))
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },

    isBatchClear() {
      const ids = Object.keys(this.brandListLoading)
      return ids.length === 0 || ids.some(item => this.brandListLoading[item])
    },
    brandCategoryCounts() {
      const ids = new Set([...Object.keys(this.brandKeyValues_def || {}), ...Object.keys(this.brandAdded)])
      Object.keys(this.brandRemoved).forEach(id => { if (this.brandRemoved[id]) ids.delete(id) })
      let configured = 0
      ids.forEach(id => {
        const brand = this.brandEdits[id] || this.brandKeyValues_def[id] || this.brandAdded[id]
        const brandId = Number(brand?.brand_id)
        if (Number.isSafeInteger(brandId) && brandId > 0) configured++
      })
      return { selected: ids.size, configured, remaining: ids.size - configured }
    },
    selectedShopIds() {
      return Object.keys(this.selectedShops)
    },
    selectedEnabledShopCount() {
      return Object.values(this.selectedShops).filter(shop => Number(shop.daily_status) === 2).length
    },
    isCurrentPageAllSelected() {
      return this.list.length > 0 && this.list.every(shop => this.isShopSelected(shop))
    },
    isCurrentPagePartiallySelected() {
      return !this.isCurrentPageAllSelected && this.list.some(shop => this.isShopSelected(shop))
    },
    strategySaveDisabled() {
      return this.strategyCategoryLoading || !this.strategyCategoryLoaded ||
        !!this.strategyCategoryError || this.strategyCategoryInvalidIds.length > 0 ||
        this.strategyGroupStatus !== 'success' ||
        this.invalidStrategyMainGroupIds.length > 0 ||
        this.zeroProductStrategyMainGroupNames.length > 0 ||
        this.zeroProductStrategyChildGroupNames.length > 0 ||
        (this.strategyForm.config.shop_product_repository_groups.length > 0 &&
          this.strategyChildGroupStatus !== 'success') ||
        (this.searchData.shop_type === 1 && (
          this.strategyBlacklistCategoryLoading ||
          !this.strategyBlacklistCategoryLoaded ||
          this.strategyBlacklistInvalidIds.length > 0
        ))
    },
    titleLetterFilterActive() {
      return Number(this.strategyForm.config.title_english_letter_min_count) > 0
    },
    shopLimitRangeText() {
      return this.formatLimitRangeText(this.shopStrategyConfig)
    },
    shopTitleLetterText() {
      return this.formatTitleLetterText(this.shopStrategyConfig)
    },
    wechatLimitRangeText() {
      return this.formatLimitRangeText(this.wechatStrategyConfig)
    },
    wechatTitleLetterText() {
      return this.formatTitleLetterText(this.wechatStrategyConfig)
    },
    wechatSaveDisabled() {
      return this.sLoading || !this.shopStrategyId || this.wechatStrategyLoading || !!this.wechatStrategyError ||
        this.wechatResourcesLoading || !!this.wechatResourcesError || this.wechatCategoryLoading || !!this.wechatCategoryError ||
        !this.wechatStrategyLoaded || !this.wechatResourcesLoaded || !this.wechatCategoriesLoaded
    },
    wechatFreightTemplateInvalid() {
      return this.wechatResourcesLoaded && !!this.wForm.freight_template_id &&
        !this.freightTemplate.some(item => String(item.id) === this.wForm.freight_template_id)
    },
    wechatReturnAddressInvalid() {
      return this.wechatResourcesLoaded && !!this.wForm.return_address_id &&
        !this.wReturnAddressList.some(item => String(item.address_id) === this.wForm.return_address_id)
    },
    wechatSelectedCategoryRows() {
      const authorized = new Map(this.wCateTableData.map(item => [String(item.category_id), item]))
      const selected = new Map(this.wSelectedCateList.map(item => [String(item.category_id), item]))
      const savedBrands = new Map()
      Object.entries(this.wechatBrandSnapshot).forEach(([key, brand]) => {
        const secondId = String(this.getSecondCategoryId(key))
        if (!savedBrands.has(secondId)) savedBrands.set(secondId, brand)
      })
      const ids = [...new Set(this.wechatEffectiveCategoryIds.map(id => String(this.getSecondCategoryId(id))))]
      return ids.map(id => {
        const category = authorized.get(id)
        const source = selected.get(id)
        return {
          id,
          path_name: category?.path_names || `类目 ID ${id}`,
          path_ids: category?.cate_path || [],
          path_names: category?.path_names ? category.path_names.split('>').map(name => name.trim()) : [],
          valid: !!category,
          source,
          brand: source ? source.brand : savedBrands.get(id) || null
        }
      })
    },
    wechatCategoryPreview() {
      const rows = this.wechatSelectedCategoryRows
      return rows.slice(0, 3).map(row => `${row.path_name}${row.valid ? '' : '（失效）'}`).join('、') + (rows.length > 3 ? '…' : '')
    },
    wechatBrandCounts() {
      const selected = this.wechatSelectedCategoryRows.length
      const configured = this.wechatSelectedCategoryRows.filter(row => this.wechatBrandValue(row.brand)).length
      return { selected, configured, remaining: selected - configured }
    },
    wechatCategoryLevelOptions() {
      return this.wechatLevelOptions(this.wechatSelectedCategoryRows, this.wechatCategoryFilter.one)
    },
    wechatCategoryFilteredRows() {
      const filter = this.wechatCategoryFilter
      return this.wechatSelectedCategoryRows.filter(row =>
        (!filter.one || String(row.path_ids[0] || '') === String(filter.one)) &&
        (!filter.two || String(row.path_ids[1] || '') === String(filter.two)))
    },
    wechatCategoryPagedRows() {
      const start = (this.wechatCategoryPage - 1) * this.wechatCategoryPageSize
      return this.wechatCategoryFilteredRows.slice(start, start + this.wechatCategoryPageSize)
    },
    wechatBrandLevelOptions() {
      return this.wechatLevelOptions(this.wechatSelectedCategoryRows, this.wechatBrandFilter.one)
    },
    wechatBrandFilteredRows() {
      const filter = this.wechatBrandFilter
      const keyword = this.wechatBrandKeyword.trim().toLowerCase()
      return this.wechatSelectedCategoryRows.filter(row => {
        if (filter.one && String(row.path_ids[0] || '') !== String(filter.one)) return false
        if (filter.two && String(row.path_ids[1] || '') !== String(filter.two)) return false
        if (filter.config === 'set' && !this.wechatBrandValue(row.brand)) return false
        if (filter.config === 'unset' && this.wechatBrandValue(row.brand)) return false
        if (keyword && !`${row.path_name} ${row.id}`.toLowerCase().includes(keyword)) return false
        return true
      })
    },
    wechatBrandPagedRows() {
      const start = (this.wechatBrandPage - 1) * this.wechatBrandPageSize
      return this.wechatBrandFilteredRows.slice(start, start + this.wechatBrandPageSize)
    },
    selectedCategoryLevelOptions() {
      const one = new Map()
      const two = new Map()
      const three = new Map()
      const filter = this.selectedCategoryFilter
      this.selectedCategoryRows.forEach(row => {
        const ids = Array.isArray(row.path_ids) ? row.path_ids : []
        const names = Array.isArray(row.path_names) ? row.path_names : []
        if (!ids.length) return
        const oneKey = String(ids[0])
        if (!one.has(oneKey)) one.set(oneKey, { id: ids[0], name: names[0] || oneKey })
        if (filter.one && String(filter.one) !== oneKey) return
        if (!ids[1]) return
        const twoKey = String(ids[1])
        if (!two.has(twoKey)) two.set(twoKey, { id: ids[1], name: names[1] || twoKey })
        if (filter.two && String(filter.two) !== twoKey) return
        if (!ids[2]) return
        const threeKey = String(ids[2])
        if (!three.has(threeKey)) three.set(threeKey, { id: ids[2], name: names[2] || threeKey })
      })
      return { one: [...one.values()], two: [...two.values()], three: [...three.values()] }
    },
    selectedCategoryFilteredRows() {
      const filter = this.selectedCategoryFilter
      return this.selectedCategoryRows.filter(row => {
        const ids = Array.isArray(row.path_ids) ? row.path_ids : []
        if (filter.one && String(ids[0] || '') !== String(filter.one)) return false
        if (filter.two && String(ids[1] || '') !== String(filter.two)) return false
        if (filter.three && String(ids[2] || '') !== String(filter.three)) return false
        return true
      })
    },
    selectedCategoryPagedRows() {
      const start = (this.selectedCategoryPage - 1) * this.selectedCategoryPageSize
      return this.selectedCategoryFilteredRows.slice(start, start + this.selectedCategoryPageSize)
    },
    brandCategoryPendingRows() {
      const savedKeys = new Set(this.brandCategoryRows.map(row => String(row.id)))
      return Object.values(this.brandAdded).filter(row => !savedKeys.has(String(row.id)))
    },
    brandCategoryPendingKeySet() {
      const keys = {}
      this.brandCategoryPendingRows.forEach(row => { keys[String(row.id)] = true })
      return keys
    },
    brandCategoryAllRows() {
      return this.brandCategoryPendingRows.concat(this.brandCategoryRows)
    },
    brandCategoryLevelOptions() {
      const one = new Map()
      const two = new Map()
      const three = new Map()
      const filter = this.brandCategoryFilter
      this.brandCategoryAllRows.forEach(row => {
        const ids = Array.isArray(row.path_ids) ? row.path_ids : []
        const names = Array.isArray(row.path_names) ? row.path_names : []
        if (!ids.length) return
        const oneKey = String(ids[0])
        if (!one.has(oneKey)) one.set(oneKey, { id: ids[0], name: names[0] || String(ids[0]) })
        if (filter.one && String(filter.one) !== oneKey) return
        if (!ids[1]) return
        const twoKey = String(ids[1])
        if (!two.has(twoKey)) two.set(twoKey, { id: ids[1], name: names[1] || String(ids[1]) })
        if (filter.two && String(filter.two) !== twoKey) return
        if (!ids[2]) return
        const threeKey = String(ids[2])
        if (!three.has(threeKey)) three.set(threeKey, { id: ids[2], name: names[2] || String(ids[2]) })
      })
      return { one: [...one.values()], two: [...two.values()], three: [...three.values()] }
    },
    brandCategoryConfiguredKeySet() {
      const keys = {}
      this.brandCategoryAllRows.forEach(row => {
        if (this.isBrandCategoryConfigured(row)) keys[String(row.id)] = true
      })
      return keys
    },
    brandCategoryFilteredRows() {
      const keyword = this.brandCategoryKeyword.trim().toLowerCase()
      const filter = this.brandCategoryFilter
      const configured = this.brandCategoryConfiguredKeySet
      return this.brandCategoryAllRows.filter(row => {
        const ids = Array.isArray(row.path_ids) ? row.path_ids : []
        if (filter.one && String(ids[0] || '') !== String(filter.one)) return false
        if (filter.two && String(ids[1] || '') !== String(filter.two)) return false
        if (filter.three && String(ids[2] || '') !== String(filter.three)) return false
        const key = String(row.id)
        if (filter.config === 'set' && !configured[key]) return false
        if (filter.config === 'unset' && configured[key]) return false
        if (keyword && !`${row.path_name || ''} ${row.id}`.toLowerCase().includes(keyword)) return false
        return true
      })
    },
    brandCategoryPagedRows() {
      const start = (this.brandCategoryPage - 1) * this.brandCategoryPageSize
      return this.brandCategoryFilteredRows.slice(start, start + this.brandCategoryPageSize)
    },
    brandCategoryPageNewUnconfiguredRows() {
      return this.brandCategoryPagedRows.filter(row => this.isBrandCategoryPending(row) && !this.brandRemoved[String(row.id)] && !this.selectedBrandValue(row))
    },
    brandCategoryPageSavedRows() {
      return this.brandCategoryPagedRows.filter(row => !this.isBrandCategoryPending(row) && !this.brandRemoved[String(row.id)])
    },
    brandCategoryPendingCount() {
      return this.brandCategoryPendingRows.length
    },
    brandCategoryRemovedCount() {
      return Object.keys(this.brandRemoved).filter(id => this.brandRemoved[id]).length
    }
  },
  created() {
    window.addEventListener('low-sales-authorization-updated', this.handleGlobalAuthorizationUpdated)
    this.is_host = !(this.$store.state.login.is_host === 'false')
    this.loadGroupList()
    this.getShopList()
    this.getTableData(1)
    this.loadStrategies()
  },
  beforeDestroy() {
    window.removeEventListener('low-sales-authorization-updated', this.handleGlobalAuthorizationUpdated)
  },
  watch: {
    'strategyForm.config.title_english_letter_min_count'(value) {
      if (!(Number(value) > 0)) this.strategyForm.config.title_english_letter_consecutive = 0
    },
    'searchData.shop_name'() {
      this.clearSelectedShops()
    },
    'searchData.shop_name_keyword'() {
      this.clearSelectedShops()
    },
    'searchData.daily_status'() {
      this.clearSelectedShops()
    },
    'searchData.low_sales'() {
      this.clearSelectedShops()
    },
    'searchData.low_sales_product_delete_authorized'() {
      this.clearSelectedShops()
    },
    'searchData.blind_box_strategy'() {
      this.clearSelectedShops()
    },
    'searchData.group_ids': {
      handler() {
        this.clearSelectedShops()
      },
      deep: true
    },
    selectedCategoryShow(value) {
      if (!value) {
        ++this.selectedCategoryRequestId
        this.selectedCategoryLoading = false
      }
    },
    brandCandidatesShow(value) {
      if (!value) {
        ++this.brandCandidatesRequestId
        ++this.brandCandidatesAddRequestId
        this.brandCandidatesAdding = false
      }
    },
    brandCategoryShow(value) {
      if (!value) {
        ++this.brandCategoryBatchRequestId
        this.brandCategoryBatchLoading = false
        this.brandCategoryBatchMode = ''
        this.brandCategoryBatchActiveId = ''
      }
    }
  },
  methods: {
    formatStrategyUpdatedAt(value) {
      const timestamp = Number(value)
      if (value === null || value === undefined || value === '' || !Number.isSafeInteger(timestamp) || timestamp <= 0 || !Number.isFinite(new Date(timestamp * 1000).getTime())) return '--'
      return common._date(timestamp, 'Y-m-d H:i:s')
    },
    ...mapActions({
      getBlindBox: 'ucenter/getBlindBox',
      updateBlindBox: 'ucenter/updateBlindBox',
      updateBlindBoxStatus: 'ucenter/updateBlindBoxStatus',
      fetchBrandList: 'ucenter/fetchBrandList',
      fetchBrandListBatch: 'ucenter/fetchBrandListBatch',
      fetchPhraseList: 'ucenter/fetchPhraseList',
      opGetTwoCategorySubList: 'ucenter/opGetTwoCategorySubList',
      getDdShopList: 'ucenter/getDdShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getCloudProductGroupsNew: 'ucenter/getCloudProductGroupsNew',
      opLowSalesProductDeleteAuthorization: "ucenter/opLowSalesProductDeleteAuthorization",
      getCelveData: 'ucenter/getCelveData',
    }),
    defaultStrategyForm() {
      return {
        id: null,
        name: '',
        config: {
          daily_num: 100,
          strategies_id: null,
          shop_limit_price: 0,
          shop_limit_price_max: 0,
          title_english_letter_min_count: 0,
          title_english_letter_consecutive: 0,
          shop_product_source: 2,
          categoryIds: '',
          shop_product_repository_skus: [],
          shop_product_repository_groups: [],
          shop_product_repository_child_groups: [],
          shop_product_repository_skus_mark: [],
          shop_category_blacklist_leaf_ids: [],
          is_sku_miss_off: 1,
          categoryLimitKeyValues: {}
        }
      }
    },
    normalizeSkuMarkStatuses(value) {
      if (!Array.isArray(value)) return []
      return Array.from(new Set(value
        .filter(status => [1, 2, 3, '1', '2', '3'].includes(status))
        .map(status => Number(status))))
    },
    loadListingStrategies() {
      this.getCelveData({
        data: { page: 1, page_size: 100 },
        success: (res) => {
          if (res.code === 200) this.listingStrategies = res.data.list || []
          else this.$message.error(res.message || '上架策略加载失败')
        }
      })
    },
    async openStrategyManager() {
      if (this.strategyShow) return
      this.strategyShow = true
      this.loadListingStrategies()
      this.loadStrategyGroupList()
      this.loadStrategies()
    },
    async loadStrategies(force = false) {
      if (!force && this.strategyLoadedPlatform === this.searchData.shop_type && this.strategyList.length) return
      this.strategyLoading = true
      try {
        const res = await blindBoxStrategyList({ shop_type: this.searchData.shop_type, page: 1, page_size: 100 })
        if (res.code === 200) {
          this.strategyList = res.data.list || []
          this.strategyLoadedPlatform = this.searchData.shop_type
        }
        else this.$message.error(res.message || '盲盒策略加载失败')
      } catch (error) {
        this.$message.error('盲盒策略加载失败，请稍后重试')
      } finally {
        this.strategyLoading = false
      }
    },
    async refreshBlindBoxList() {
      this.strategyLoadedPlatform = null
      await Promise.all([
        this.loadStrategies(true),
        this.getTableData(this.pageData.page)
      ])
    },
    isShopSelected(shop) {
      return Boolean(this.selectedShops[String(shop.mer_shop_id)])
    },
    toggleShop(shop, checked) {
      const id = String(shop.mer_shop_id)
      if (checked) {
        this.$set(this.selectedShops, id, {
          mer_shop_id: Number(shop.mer_shop_id),
          shop_name: shop.shop_name,
          daily_status: shop.daily_status
        })
        return
      }
      this.$delete(this.selectedShops, id)
    },
    toggleSelectAll(checked) {
      this.list.forEach(shop => this.toggleShop(shop, checked))
    },
    clearSelectedShops() {
      this.selectedShops = {}
    },
    openBatchStrategy() {
      if (!this.selectedShopIds.length) {
        this.$message.warning('请先勾选店铺')
        return
      }
      this.batchStrategyId = null
      this.batchStrategyShow = true
      this.loadStrategies().then(() => {
        if (!this.strategyList.length) this.$message.warning('请先创建盲盒策略')
      })
    },
    async saveBatchStrategy() {
      if (!this.batchStrategyId || !this.selectedShopIds.length) {
        this.$message.warning('请选择策略和店铺')
        return
      }
      this.batchStrategySaving = true
      try {
        const res = await bindBlindBoxStrategy(this.batchStrategyId, {
          mer_shop_ids: this.selectedShopIds.map(id => Number(id))
        })
        if (res.code !== 200) {
          this.$message.error(res.message || '绑定失败')
          return
        }
        this.$message.success('绑定成功')
        this.batchStrategyShow = false
        this.clearSelectedShops()
        await this.refreshBlindBoxList()
      } catch (error) {
        this.$message.error('网络异常，绑定失败')
      } finally {
        this.batchStrategySaving = false
      }
    },
    newStrategy() {
      this.strategyForm = this.defaultStrategyForm()
      this.strategyChildGroups = []
      this.strategyChildGroupStatus = 'idle'
      ++this.strategyChildGroupRequestId
      this.strategyCategoryIds = []
      this.strategyWechatCategoryPaths = []
      this.strategyCategoryTree = []
      this.strategyCategoryLoaded = false
      this.strategyCategoryError = ''
      this.strategyCategoryInvalidIds = []
      ++this.strategyCategoryRequestId
      this.strategyBlacklistCategoryTree = []
      this.strategyBlacklistCategoryPaths = []
      this.strategyBlacklistInvalidIds = []
      this.strategyFormShow = true
      this.loadStrategyCategoryTree()
      if (this.searchData.shop_type === 1) {
        this.loadStrategyBlacklistCategoryTree([])
      }
    },
    editStrategy(row) {
      const config = JSON.parse(JSON.stringify(row.config || {}))
      config.shop_product_source = 2
      config.shop_product_repository_skus = config.shop_product_repository_skus || []
      config.shop_product_repository_groups = config.shop_product_repository_groups || []
      config.shop_product_repository_child_groups = config.shop_product_repository_child_groups || []
      config.shop_product_repository_skus_mark = this.normalizeSkuMarkStatuses(config.shop_product_repository_skus_mark)
      config.shop_category_blacklist_leaf_ids = Array.isArray(config.shop_category_blacklist_leaf_ids)
        ? config.shop_category_blacklist_leaf_ids
        : []
      config.is_sku_miss_off = config.is_sku_miss_off || 1
      config.shop_limit_price_max = config.shop_limit_price_max ?? 0
      config.title_english_letter_min_count = config.title_english_letter_min_count ?? 0
      config.title_english_letter_consecutive = Number(config.title_english_letter_min_count) > 0
        && Number(config.title_english_letter_consecutive) === 1 ? 1 : 0
      this.strategyForm = { id: row.id, name: row.name, config: { ...this.defaultStrategyForm().config, ...config } }
      this.strategyCategoryIds = String(config.categoryIds || '').split(',').filter(Boolean)
      this.strategyWechatCategoryPaths = []
      this.strategyCategoryTree = []
      this.strategyCategoryLoaded = false
      this.strategyCategoryError = ''
      this.strategyCategoryInvalidIds = []
      ++this.strategyCategoryRequestId
      this.strategyBlacklistCategoryTree = []
      this.strategyBlacklistCategoryPaths = []
      this.strategyBlacklistInvalidIds = []
      this.loadStrategyChildGroups()
      this.strategyFormShow = true
      this.loadStrategyCategoryTree()
      if (this.searchData.shop_type === 1) {
        this.loadStrategyBlacklistCategoryTree(config.shop_category_blacklist_leaf_ids)
      }
    },
    async loadStrategyBlacklistCategoryTree(selectedIds = []) {
      const requestId = ++this.strategyBlacklistCategoryRequestId
      this.strategyBlacklistCategoryLoading = true
      this.strategyBlacklistCategoryLoaded = false
      this.strategyBlacklistCategoryError = false
      try {
        const res = await blindBoxStrategyBlacklistCategoryTree()
        if (requestId !== this.strategyBlacklistCategoryRequestId) return
        if (res.code !== 200 || !Array.isArray(res.data) || !res.data.length) {
          throw new Error(res.message || '抖店黑名单类目加载失败')
        }

        this.formatCategory(res.data)

        const requestedIdSet = new Set((Array.isArray(selectedIds) ? selectedIds : []).map(id => String(Number(id))))
        const foundIds = new Set()
        const selectedPaths = []
        const walk = (nodes, parentPath = []) => {
          ;(Array.isArray(nodes) ? nodes : []).forEach(node => {
            const categoryId = Number(node.category_id)
            const path = parentPath.concat(categoryId)
            const children = Array.isArray(node.sub_category) ? node.sub_category : []
            if (children.length) {
              walk(children, path)
            } else if (requestedIdSet.has(String(categoryId))) {
              selectedPaths.push(path)
              foundIds.add(String(categoryId))
            }
          })
        }
        walk(res.data)

        this.strategyBlacklistCategoryTree = res.data
        this.strategyBlacklistCategoryPaths = selectedPaths
        this.strategyBlacklistInvalidIds = Array.from(requestedIdSet).filter(id => !foundIds.has(id))
        this.strategyBlacklistCategoryLoaded = true
      } catch (error) {
        if (requestId !== this.strategyBlacklistCategoryRequestId) return
        this.strategyBlacklistCategoryError = true
        this.$message.error(error.message || '黑名单类目加载失败，请稍后重试')
      } finally {
        if (requestId === this.strategyBlacklistCategoryRequestId) {
          this.strategyBlacklistCategoryLoading = false
        }
      }
    },
    async confirmRemoveInvalidBlacklistIds() {
      if (!this.strategyBlacklistInvalidIds.length) return
      try {
        await this.$confirm(
          `确认从策略黑名单中移除失效类目 ID：${this.strategyBlacklistInvalidIds.join('、')}？`,
          '移除失效类目',
          { type: 'warning' }
        )
        this.strategyBlacklistInvalidIds = []
        this.strategyForm.config.shop_category_blacklist_leaf_ids = this.strategyBlacklistCategoryPaths
          .map(path => Number(path[path.length - 1]))
      } catch (error) {
        // 取消确认时保留原有黑名单。
      }
    },
    async loadStrategyCategoryTree() {
      const requestId = ++this.strategyCategoryRequestId
      const requestedIds = Array.from(new Set([...this.strategyCategoryIds, ...this.strategyCategoryInvalidIds].map(id => String(id))))
      this.strategyCategoryLoading = true
      this.strategyCategoryLoaded = false
      this.strategyCategoryError = ''
      this.strategyCategoryTree = []
      try {
        const res = await blindBoxStrategyCategoryTree({ shop_type: this.searchData.shop_type })
        if (requestId !== this.strategyCategoryRequestId) return
        if (res?.code !== 200 || !Array.isArray(res.data) || !res.data.length) throw new Error(res?.message || '铺货类目为空或加载失败')
        const leaves = new Map()
        res.data.forEach(root => {
          ;(Array.isArray(root.sub_category) ? root.sub_category : []).forEach(category => {
            if (category.category_id !== undefined && category.category_id !== null && !Array.isArray(category.sub_category)) {
              leaves.set(String(category.category_id), { id: category.category_id, path: [root.category_id, category.category_id] })
            }
          })
        })
        if (!leaves.size) throw new Error('铺货类目为空，请稍后重试')
        this.strategyCategoryTree = res.data
        this.strategyCategoryIds = requestedIds.filter(id => leaves.has(id)).map(id => leaves.get(id).id)
        this.strategyWechatCategoryPaths = this.searchData.shop_type === 7
          ? requestedIds.filter(id => leaves.has(id)).map(id => leaves.get(id).path)
          : []
        this.strategyCategoryInvalidIds = requestedIds.filter(id => !leaves.has(id))
        this.strategyCategoryLoaded = true
      } catch (error) {
        if (requestId === this.strategyCategoryRequestId) this.strategyCategoryError = error?.message || '铺货类目加载失败，请稍后重试'
      } finally {
        if (requestId === this.strategyCategoryRequestId) this.strategyCategoryLoading = false
      }
    },
    onStrategyWechatCategoriesChange(paths) {
      this.strategyCategoryIds = Array.from(new Set((paths || [])
        .filter(path => Array.isArray(path) && path.length === 2)
        .map(path => path[1])))
    },
    async confirmRemoveInvalidStrategyCategories() {
      if (!this.strategyCategoryInvalidIds.length) return
      try {
        await this.$confirm(`确认移除已失效的历史类目 ID：${this.strategyCategoryInvalidIds.join('、')}？`, '移除失效类目', { type: 'warning' })
        this.strategyCategoryInvalidIds = []
      } catch (error) {
        // 取消时保留历史类目，禁止保存。
      }
    },
    strategyMainGroupLabel(group) {
      return `${group.name}${group.is_shared ? '【共享】' : ''}`
    },
    strategyChildGroupLabel(group) {
      return `${group.parent_name} / ${group.name}${group.is_shared ? '【共享】' : ''}`
    },
    hasStrategyProductCount(group) {
      return group.product_count !== undefined && group.product_count !== null && group.product_count !== '' &&
        Number.isFinite(Number(group.product_count)) && Number(group.product_count) >= 0
    },
    isZeroStrategyProductCount(group) {
      return this.hasStrategyProductCount(group) && Number(group.product_count) === 0
    },
    isStrategyGroupOptionDisabled(group, selectedIds) {
      return this.isZeroStrategyProductCount(group) &&
        !selectedIds.some(id => String(id) === String(group.id))
    },
    async loadStrategyGroupList() {
      const requestId = ++this.strategyGroupRequestId
      this.strategyGroupStatus = 'loading'
      if (this.strategyFormShow && this.strategyForm.config.shop_product_repository_groups.length) {
        this.strategyChildGroupStatus = 'loading'
      }
      try {
        const res = await cloudProductGroups({ with_count: 1, view_share: 1 })
        if (requestId !== this.strategyGroupRequestId) return
        if (res.code !== 200 || !Array.isArray(res.data)) throw new Error(res.message || '分组加载失败')
        this.strategyGroupList = res.data
        this.strategyGroupStatus = 'success'
        if (this.strategyFormShow) this.loadStrategyChildGroups()
      } catch (error) {
        if (requestId !== this.strategyGroupRequestId) return
        this.strategyGroupStatus = 'error'
        if (this.strategyFormShow && this.strategyForm.config.shop_product_repository_groups.length) {
          this.strategyChildGroupStatus = 'error'
        }
      }
    },
    loadStrategyChildGroups() {
      ++this.strategyChildGroupRequestId
      const parentIds = [...(this.strategyForm.config.shop_product_repository_groups || [])]
      if (!parentIds.length) {
        this.strategyChildGroups = []
        this.strategyChildGroupStatus = 'idle'
        this.strategyForm.config.shop_product_repository_child_groups = []
        return
      }
      if (this.strategyGroupStatus !== 'success') {
        this.strategyChildGroupStatus = this.strategyGroupStatus === 'error' ? 'error' : 'loading'
        return
      }
      const mainOptions = new Map(this.strategyGroupList.map(group => [String(group.id), group.id]))
      this.strategyForm.config.shop_product_repository_groups = parentIds
        .map(id => mainOptions.has(String(id)) ? mainOptions.get(String(id)) : id)
      const parentSet = new Set(parentIds.map(id => String(id)))
      this.strategyChildGroups = this.strategyGroupList
        .filter(group => parentSet.has(String(group.id)) && group.name)
        .flatMap(parent => (Array.isArray(parent.child_groups) ? parent.child_groups : [])
          .filter(child => child.name)
          .map(child => ({ ...child, parent_name: parent.name })))
      const available = new Map(this.strategyChildGroups.map(group => [String(group.id), group.id]))
      this.strategyForm.config.shop_product_repository_child_groups = this.strategyForm.config.shop_product_repository_child_groups
        .filter(id => available.has(String(id)))
        .map(id => available.get(String(id)))
      this.strategyChildGroupStatus = 'success'
    },
    async saveStrategy() {
      const form = this.strategyForm
      const config = { ...form.config }
      if (this.invalidStrategyMainGroupIds.length) {
        this.$message.error('存在已失效的主分组，请重新选择')
        return
      }
      if (this.zeroProductStrategyMainGroupNames.length || this.zeroProductStrategyChildGroupNames.length) {
        this.$message.error(`已选分组无商品：${[...this.zeroProductStrategyMainGroupNames, ...this.zeroProductStrategyChildGroupNames].join('、')}，请移除或改选`)
        return
      }
      if (config.shop_product_repository_groups.length && this.missingStrategyGroupNames.length) {
        this.$message.error(`主分组 ${this.missingStrategyGroupNames.join('、')} 至少选择一个子分组`)
        return
      }
      if (this.strategyGroupStatus !== 'success' ||
        (config.shop_product_repository_groups.length && this.strategyChildGroupStatus !== 'success')) {
        this.$message.error('云商品分组加载失败或尚未完成，请重试')
        return
      }
      if (this.strategySaveDisabled) {
        this.$message.error('请先成功加载铺货类目并处理失效项')
        return
      }
      config.categoryIds = (this.searchData.shop_type === 7
        ? Array.from(new Set(this.strategyWechatCategoryPaths.filter(path => Array.isArray(path) && path.length === 2).map(path => String(path[1]))))
        : Array.from(new Set(this.strategyCategoryIds.map(id => String(id))))).join(',')
      if (!form.name || !config.strategies_id || !config.categoryIds) {
        this.$message.error('请填写策略名称、上架策略和铺货类目')
        return
      }
      if (Number(config.shop_limit_price_max) > 0 && Number(config.shop_limit_price_max) < Number(config.shop_limit_price)) {
        this.$message.error('限价区间大价不能低于小价')
        return
      }
      if (this.searchData.shop_type === 1 && !this.strategyBlacklistCategoryLoaded) {
        this.$message.error('请先成功加载抖店黑名单类目')
        return
      }
      if (this.searchData.shop_type === 1 && this.strategyBlacklistInvalidIds.length) {
        this.$message.error('请先确认移除失效的黑名单类目')
        return
      }
      config.shop_product_source = 2
      config.shop_product_repository_skus_mark = this.normalizeSkuMarkStatuses(config.shop_product_repository_skus_mark)
      config.title_english_letter_consecutive = Number(config.title_english_letter_min_count) > 0
        && Number(config.title_english_letter_consecutive) === 1 ? 1 : 0
      if (this.searchData.shop_type === 1) {
        config.shop_category_blacklist_leaf_ids = Array.from(new Set(
          (this.strategyBlacklistCategoryPaths || [])
            .map(path => Number(Array.isArray(path) ? path[path.length - 1] : path))
            .filter(id => Number.isInteger(id) && id > 0)
        ))
      }
      const payload = { name: form.name, shop_type: this.searchData.shop_type, config }
      this.strategySaving = true
      try {
        const res = form.id ? await updateBlindBoxStrategy(form.id, payload) : await createBlindBoxStrategy(payload)
        if (res.code !== 200) {
          this.$message.error(res.message || '保存失败')
          return
        }
        this.$message.success('保存成功')
        this.strategyFormShow = false
        await this.refreshBlindBoxList()
      } catch (error) {
        this.$message.error('网络异常，保存失败')
      } finally {
        this.strategySaving = false
      }
    },
    async removeStrategy(row) {
      try {
        await this.$confirm(`确定删除策略「${row.name}」吗？已绑定店铺的策略无法删除。`, '提示', { type: 'warning' })
        const res = await deleteBlindBoxStrategy(row.id)
        if (res.code !== 200) {
          this.$message.error(res.message || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.refreshBlindBoxList()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error('删除失败，请稍后重试')
      }
    },
    async unbindStrategy(shop) {
      try {
        await this.$confirm(`确定解绑店铺「${shop.shop_name}」的盲盒策略吗？仅暂停店铺允许解绑。`, '提示', { type: 'warning' })
        const res = await unbindBlindBoxStrategy(shop.mer_shop_id)
        if (res.code !== 200) return this.$message.error(res.message || '解绑失败')
        this.$message.success('解绑成功')
        await this.refreshBlindBoxList()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error('解绑失败，请稍后重试')
      }
    },
    keywordOptions(arr) {
      return (arr || []).map(k => ({ id: k, name: k }))
    },
    formatAddress(item) {
      const parts = [item.province, item.city, item.area, item.detail].filter(p => p)
      const address = parts.join('')
      const contact = [item.name, item.phone_number].filter(p => p).join(' ')
      return contact ? `${address}（${contact}）` : address
    },
    setChange() {
      // if(this.$store.state.login.user_level == 9 && this.searchData.group_ids) {
      //   this.searchData.group_ids = []
      //   this.$message.error('普通会员无法使用分组');
      //   return
      // }
    },
    /**
     *  ── 列表 ── */
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const list = res.data || []
            if (this.is_host) list.push({ id: -1, name: '未分组' })
            this.groupList = list
          }
        }
      })
    },
    getShopList() {
      this.getDdShopList({
        data: { page_size: 100, page: 1, shop_type: this.searchData.shop_type },
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            this.shopList = d.list && d.list.list ? d.list.list : (Array.isArray(d.list) ? d.list : [])
            this.unauthorized_quantity = res.data?.unauthorized_quantity??0
            this.authorized_quantity = res.data?.authorized_quantity??50
          }
        }
      })
    },
    bindShopTypeChange(type) {
      if (this.searchData.shop_type === type) return
      this.searchData.shop_type = type
      this.strategyLoadedPlatform = null
      this.strategyList = []
      this.clearSelectedShops()
      this.pageData.page = 1
      this.handleReset()
      this.getShopList()
      this.loadStrategies()
    },
    handleSearch() {
      this.list = []
      this.clearSelectedShops()
      this.pageData.page = 1
      this.getTableData(1)
    },
    handleReset() {
      this.searchData.shop_name = ''
      this.searchData.shop_name_keyword = ''
      this.searchData.daily_status = ''
      this.searchData.group_ids = []
      this.searchData.low_sales = ''
      this.searchData.low_sales_product_delete_authorized = ''
      this.searchData.blind_box_strategy = ''
      this.handleSearch()
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getTableData(1)
    },
    //读取店铺低动销状态（列表接口已返回 shop_product_quota，缺失视为未知）
    getShopQuota(row) {
      return (row && row.shop_product_quota) || { is_low_sales_shop: null, daily_quota: null }
    },
    toFiniteNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const number = Number(value)
      return Number.isFinite(number) ? number : null
    },
    formatQuantity(value) {
      const number = this.toFiniteNumber(value)
      return number === null ? '--' : String(Math.max(0, Math.trunc(number)))
    },
    getDailyPublishQuota(row) {
      if (row && row.daily_publish_quota !== null && row.daily_publish_quota !== undefined && row.daily_publish_quota !== '') {
        return row.daily_publish_quota
      }
      if (Number(this.searchData.shop_type) !== 1) return null
      if (!row || row.low_sales_product_delete_authorized != 1) return 0
      const shopQuota = this.getShopQuota(row)
      if ([false, 0, '0'].includes(shopQuota.is_low_sales_shop)) return 50
      const quota = this.toFiniteNumber(shopQuota.daily_quota)
      return quota === null ? 50 : Math.min(50, Math.max(0, Math.trunc(quota)))
    },
    getRemainingQuota(row) {
      const total = this.toFiniteNumber(this.getDailyPublishQuota(row))
      const used = this.toFiniteNumber(row && row.today_success)
      return total === null || used === null ? '--' : this.formatQuantity(Math.max(total - used, 0))
    },
    getSalesAssessment(row) {
      return row && row.sales_assessment && typeof row.sales_assessment === 'object'
        ? row.sales_assessment
        : null
    },
    getSalesAssessmentState(row) {
      const assessment = this.getSalesAssessment(row)
      if (!assessment) return 'pending'

      const syncStatus = this.toFiniteNumber(assessment.sync_status)
      const assessmentStatus = this.toFiniteNumber(assessment.assessment_status)
      if (syncStatus === 2) return 'failed'
      if (syncStatus === 0) return 'syncing'
      if (assessmentStatus === 3) return 'not-applicable'
      if (assessmentStatus === 1) return 'qualified'
      if (assessmentStatus === 2) return 'unqualified'
      return 'pending'
    },
    isSalesAssessmentReady(row) {
      return ['qualified', 'unqualified'].includes(this.getSalesAssessmentState(row))
    },
    getSalesAssessmentLabel(row) {
      return {
        qualified: '已达标',
        unqualified: '未达标',
        pending: '待同步',
        syncing: '同步中',
        failed: '同步失败',
        'not-applicable': '不适用'
      }[this.getSalesAssessmentState(row)]
    },
    getSalesAssessmentClass(row) {
      return this.getSalesAssessmentState(row) === 'qualified'
        ? 'text-green'
        : this.getSalesAssessmentState(row) === 'unqualified'
          ? 'text-red'
          : ''
    },
    formatSalesRate(row) {
      if (!this.isSalesAssessmentReady(row)) return '--'
      const rate = this.toFiniteNumber(this.getSalesAssessment(row).sales_rate)
      return rate === null ? '--' : `${(rate * 100).toFixed(2)}%`
    },
    formatEffectiveSalesProductCount(row) {
      if (!this.isSalesAssessmentReady(row)) return '--'
      return this.formatQuantity(this.getSalesAssessment(row).effective_sales_product_count)
    },
    formatAppWindowOnlineProductCount(row) {
      if (!this.isSalesAssessmentReady(row)) return this.getSalesAssessmentLabel(row)
      return `本系统30天考核窗口在架 ${this.formatQuantity(this.getSalesAssessment(row).app_window_online_product_count)} 件`
    },
    formatSalesGap(row) {
      const state = this.getSalesAssessmentState(row)
      if (state === 'qualified') return '已达标'
      if (state !== 'unqualified') return '--'
      const gap = this.formatQuantity(this.getSalesAssessment(row).gap_product_count)
      return gap === '--' ? '--' : `差 ${gap} 件`
    },
    formatSalesTarget(row) {
      if (!this.isSalesAssessmentReady(row)) return this.getSalesAssessmentLabel(row)
      const target = this.formatQuantity(this.getSalesAssessment(row).target_product_count)
      return target === '--' ? '--' : `目标 ${target} 件`
    },
    getTableData(page) {
      this.pageData.page = page || this.pageData.page
      const param = { page_size: this.pageData.limit, page: this.pageData.page, ...this.searchData }
      delete param.blind_box_strategy
      if (this.searchData.blind_box_strategy === '__unbound__') {
        param.blind_box_strategy_status = 'unbound'
      } else if (this.searchData.blind_box_strategy) {
        param.blind_box_strategy_id = this.searchData.blind_box_strategy
      }
      return new Promise((resolve) => {
        this.loadingStart()
        this.getBlindBox({
          data: param,
          success: (res) => {
            this.loadingEnd()
            if (res.code === 200) {
              this.list = res.data.list || []
              this.pageData.total = res.data.total || 0
            } else {
              this.$message.error(res.message)
            }
            resolve(res)
          }
        })
      })
    },
    handleGlobalAuthorizationUpdated() {
      if (this.$route.path.indexOf('/new_cloud_workbench') > -1) this.getTableData(this.pageData.page)
    },
    toggleStatus(row) {
      const target = row.daily_status === 2 ? 1 : 2
      this.$confirm(`确定${target === 2 ? '启用' : '停用'}店铺「${row.shop_name}」的盲盒吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateBlindBoxStatus({
          data: { shop_id: row.shop_id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.getTableData(this.pageData.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },

    /**
     *  ── 低效品下架授权 ── */
    updateLowSalesAuth(row){
      const status = row.low_sales_product_delete_authorized == 1 ? 0 : 1
      if (status === 0 && this.isLowSalesAuthorizationDisableBlocked(row)) {
        this.$message.warning('店铺商品应用授权仍有效且未到期，暂不能关闭‘授权下架低效品’。')
        return
      }
      const params={shop_ids:[row.shop_id],low_sales_product_delete_authorized:status}
      const opening = status === 1
      const notice = opening
        ? this.$createElement(LowSalesAuthorizationNotice, { props: { shopName: String(row.shop_name || '') } })
        : '关闭授权后，每日铺货额度为 0。'
      this.$confirm(notice, opening ? '开启低效品下架授权' : '关闭授权提示', {
        showCancelButton: true,
        customClass: opening ? 'low-sales-authorization-confirm' : '',
        confirmButtonText: opening ? '同意并开启授权' : '确定',
        cancelButtonText: opening ? '暂不开启' : '取消'
      }).then(()=>{
        this.opLowSalesProductDeleteAuthorization({
          data:params,
          success:(res)=>{
            if(res.code==200){
              this.$message.success(`${row.shop_name}已成功${status==1?'开启':'关闭'}店铺的低效品下架授权。`)
              this.getTableData(this.pageData.page)
            }else {
              this.$message.error(res.msg||res.message||'操作失败，请稍后重试')
            }
          },
          fail:()=>{
            this.$message.error('网络异常，请稍后重试')
          }
        })
      }).catch(() => {})
    },
    isLowSalesAuthorizationDisableBlocked(row) {
      return !!(row && row.low_sales_product_delete_authorized == 1 && row.can_disable_low_sales_product_delete_authorization === false)
    },
    /**
     * ── 编辑入口 ── */
    manageShop(shop) {
      const requestId = ++this.shopEditRequestId
      this.shopEditSource = { ...shop }
      this.currentShop = {
        ...shop,
        shop_product_repository_skus_mark: this.normalizeSkuMarkStatuses(shop.shop_product_repository_skus_mark)
      }
      this.sLoading = false
      this.shopStrategyId = null
      this.shopStrategyDetailLoading = false
      this.shopStrategyDetailError = ''
      this.shopPublishCategoryIds = []
      this.shopResourcesLoading = false
      this.shopResourcesError = ''
      if (this.searchData.shop_type === 7) {
        this.openWechatEdit(shop)
        return
      }
      this.editType = 'douyin'
      this.editShow = true
      const strategyId = Number(shop.blind_box_strategy_id || shop.blind_box_strategy?.id)
      this.shopStrategyId = Number.isInteger(strategyId) && strategyId > 0 ? strategyId : null
      this.shopStrategyConfig = null
      this.shopStrategyDetailLoading = this.shopStrategyId !== null
      if (this.shopStrategyId) this.clearShopSharedDisplay()
      else this.applyShopSharedConfig(shop)
      this.brandKeyValues_def = { ...(shop.brandKeyValues || {}) }
      this.brandAdded = {}
      this.brandRemoved = {}
      this.brandEdits = {}
      this.brandOptions = {}
      this.brandOptionsLoading = {}
      this.selectedCategoryShow = false
      this.brandCandidatesShow = false
      this.brandCategoryShow = false
      Object.keys(this.brandCandidateOptionsRequestId).forEach(key => { ++this.brandCandidateOptionsRequestId[key] })
      this.brandCategorySelection = []
      ++this.brandCategoryBatchRequestId
      this.brandCategoryBatchLoading = false
      this.brandCategoryBatchMode = ''
      this.brandCategoryBatchActiveId = ''
      ++this.selectedCategoryRequestId
      ++this.brandCandidatesRequestId
      ++this.brandCategoryRequestId
      this.freightTemplate = []
      this.strategiesList = []
      this.categorySummary = this.emptyCategorySummary()
      this.categorySummaryError = ''
      this.categorySummaryLoading = true
      this.loadCloudGroupList()
      this.manageTitle = '编辑 - '+shop.shop_name
      if (this.shopStrategyId) this.loadShopStrategyDetail(requestId, shop.shop_id)
      this.loadShopResources(requestId, shop.shop_id)
      this.loadShopCategorySummary(requestId, shop.shop_id, shop.mer_shop_id)
    },
    isCurrentDouyinEdit(requestId, shopId) {
      return this.editShow && this.editType === 'douyin' &&
        this.shopEditRequestId === requestId && String(this.currentShop.shop_id) === String(shopId)
    },
    clearShopSharedDisplay() {
      this.$set(this.currentShop, 'shop_limit_price', null)
      this.$set(this.currentShop, 'strategies_id', null)
      this.$set(this.currentShop, 'shop_product_source', null)
      this.$set(this.currentShop, 'shop_product_repository_skus', [])
      this.$set(this.currentShop, 'shop_product_repository_skus_mark', [])
      this.$set(this.currentShop, 'shop_product_repository_groups', [])
      this.$set(this.currentShop, 'shop_product_repository_child_groups', [])
      this.$set(this.currentShop, 'daily_num', null)
      this.$set(this.currentShop, 'is_sku_miss_off', null)
      this.$set(this.currentShop, 'categoryLimitKeyValues', {})
    },
    applyShopSharedConfig(config) {
      this.$set(this.currentShop, 'shop_limit_price', config.shop_limit_price ?? null)
      this.$set(this.currentShop, 'strategies_id', config.strategies_id ?? null)
      this.$set(this.currentShop, 'shop_product_source', Number(config.shop_product_source) === 1 ? 2 : (config.shop_product_source ?? 2))
      this.$set(this.currentShop, 'shop_product_repository_skus', Array.isArray(config.shop_product_repository_skus) ? config.shop_product_repository_skus : [])
      this.$set(this.currentShop, 'shop_product_repository_skus_mark', this.normalizeSkuMarkStatuses(config.shop_product_repository_skus_mark))
      const groups = Array.isArray(config.shop_product_repository_groups) ? config.shop_product_repository_groups : []
      const childGroups = Array.isArray(config.shop_product_repository_child_groups) ? config.shop_product_repository_child_groups : []
      this.$set(this.currentShop, 'shop_product_repository_groups', groups.map(id => Number(id)))
      this.$set(this.currentShop, 'shop_product_repository_child_groups', childGroups.map(id => Number(id)))
      this.$set(this.currentShop, 'daily_num', config.daily_num ?? null)
      this.$set(this.currentShop, 'is_sku_miss_off', config.is_sku_miss_off ?? 1)
      this.$set(this.currentShop, 'categoryLimitKeyValues', config.categoryLimitKeyValues || {})
      this.getGroupChilder()
    },
    applyShopStrategyDetail(res) {
      if (res?.code !== 200 || !res.data || Number(res.data.id) !== this.shopStrategyId ||
        Number(res.data.shop_type) !== 1 || !res.data.config || typeof res.data.config !== 'object' || Array.isArray(res.data.config)) {
        throw new Error(res?.message || '当前盲盒策略加载失败，请重试')
      }
      this.applyShopSharedConfig(res.data.config)
      this.shopStrategyConfig = res.data.config
      this.shopPublishCategoryIds = this.normalizeShopPublishCategoryIds(res.data.config.categoryIds)
    },
    normalizeShopPublishCategoryIds(value) {
      return Array.from(new Set(String(value ?? '').split(',').map(id => id.trim()).filter(id => /^[1-9]\d*$/.test(id))))
    },
    formatLimitRangeText(config) {
      if (!config || typeof config !== 'object' || Array.isArray(config)) return '--'
      const min = Number(config.shop_limit_price ?? 0)
      const max = Number(config.shop_limit_price_max ?? 0)
      const minText = Number.isFinite(min) ? min.toFixed(2) : '0.00'
      const maxText = Number.isFinite(max) && max > 0 ? `最高 ${max.toFixed(2)} 元` : '最高不限'
      return `最低 ${minText} 元 ~ ${maxText}`
    },
    formatTitleLetterText(config) {
      if (!config || typeof config !== 'object' || Array.isArray(config)) return '--'
      const count = Number(config.title_english_letter_min_count ?? 0)
      if (!(count > 0)) return '不过滤'
      const consecutive = Number(config.title_english_letter_consecutive) === 1 ? '“连续”' : ''
      return `过滤标题超过“${count}”个${consecutive}英文字母的商品`
    },
    async retryShopStrategyDetail() {
      if (!this.shopEditSource || this.shopStrategyDetailLoading) return
      this.loadShopStrategyDetail(this.shopEditRequestId, this.currentShop.shop_id)
    },
    emptyCategorySummary() {
      return { publish: { total: 0, preview: [] }, blacklist: { total: 0, preview: [] }, brand: { total: 0, preview: [] } }
    },
    categoryPreviewText(kind) {
      const summary = this.categorySummary[kind]
      if (!summary || !Array.isArray(summary.preview) || !summary.preview.length) return ''
      return summary.preview.map(item => `${item.path_name || item.id}${item.valid ? '' : '（失效）'}`).join('、') + (summary.total > summary.preview.length ? '…' : '')
    },
    async loadShopStrategyDetail(requestId, shopId) {
      if (!this.shopStrategyId) return
      this.shopStrategyDetailLoading = true
      this.shopStrategyDetailError = ''
      const strategyId = this.shopStrategyId
      try {
        const res = await getBlindBoxStrategy(strategyId)
        if (!this.isCurrentDouyinEdit(requestId, shopId) || this.shopStrategyId !== strategyId) return
        this.applyShopStrategyDetail(res)
      } catch (error) {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.shopStrategyDetailError = error?.message || '当前盲盒策略加载失败，请重试'
      } finally {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.shopStrategyDetailLoading = false
      }
    },
    async loadShopResources(requestId, shopId) {
      this.shopResourcesLoading = true
      this.shopResourcesError = ''
      try {
        const res = await blindBoxDetail({ shop_id: shopId, shop_type: 1 })
        if (!this.isCurrentDouyinEdit(requestId, shopId)) return
        if (res?.code !== 200 || !res.data) throw new Error(res?.message || '店铺资源加载失败')
        const data = res.data
        this.freightTemplate = (data.shop_freight_template_list || []).map(item => item.template).filter(Boolean)
        this.strategiesList = data.strategies_list || []
        this.maxAutoNum = Number(data.max_auto_num) || 0
        this.defaultNum = Number(data.default_num) || 0
        this.defaultRatio = Number(data.default_ratio) || 0
        if (data.brandKeyValues && typeof data.brandKeyValues === 'object' && !Array.isArray(data.brandKeyValues)) {
          this.brandKeyValues_def = { ...data.brandKeyValues }
        }
      } catch (error) {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.shopResourcesError = error?.message || '店铺资源加载失败，请重试'
      } finally {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.shopResourcesLoading = false
      }
    },
    retryShopResources() {
      if (!this.shopResourcesLoading && this.editType === 'douyin') this.loadShopResources(this.shopEditRequestId, this.currentShop.shop_id)
    },
    async loadShopCategorySummary(requestId = this.shopEditRequestId, shopId = this.currentShop.shop_id, merShopId = this.currentShop.mer_shop_id) {
      this.categorySummaryLoading = true
      this.categorySummaryError = ''
      try {
        if (!merShopId) throw new Error('缺少店铺标识，无法加载类目摘要')
        const res = await getBlindBoxShopCategorySummary(merShopId)
        if (!this.isCurrentDouyinEdit(requestId, shopId)) return
        if (res?.code !== 200 || !res.data) throw new Error(res?.message || '类目摘要加载失败')
        const summary = this.emptyCategorySummary()
        for (const kind of ['publish', 'blacklist', 'brand']) {
          const value = res.data[kind]
          if (!value || !Array.isArray(value.preview) || !Number.isFinite(Number(value.total))) throw new Error('类目摘要响应异常')
          summary[kind] = { total: Number(value.total), preview: value.preview }
        }
        this.categorySummary = summary
      } catch (error) {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.categorySummaryError = error?.message || '类目摘要加载失败，请重试'
      } finally {
        if (this.isCurrentDouyinEdit(requestId, shopId)) this.categorySummaryLoading = false
      }
    },
    openSelectedCategories(kind) {
      if (kind === 'brand') return this.openBrandCategoryDialog()
      if (this.categorySummaryLoading || this.categorySummaryError) return
      this.selectedCategoryKind = kind
      this.selectedCategoryFilter = { one: '', two: '', three: '' }
      this.selectedCategoryPage = 1
      this.selectedCategoryPageSize = 50
      this.selectedCategoryRows = []
      this.selectedCategoryShow = true
      this.loadSelectedCategories()
    },
    onSelectedCategoryFilterChange() {
      this.selectedCategoryPage = 1
    },
    onSelectedCategoryOneChange() {
      this.selectedCategoryFilter.two = ''
      this.selectedCategoryFilter.three = ''
      this.selectedCategoryPage = 1
    },
    onSelectedCategoryTwoChange() {
      this.selectedCategoryFilter.three = ''
      this.selectedCategoryPage = 1
    },
    onSelectedCategoryPageChange(page) {
      this.selectedCategoryPage = page
    },
    onSelectedCategoryPageSizeChange(size) {
      this.selectedCategoryPageSize = size
      this.selectedCategoryPage = 1
    },
    openBrandCategoryDialog() {
      if (this.categorySummaryLoading || this.categorySummaryError) return
      if (this.shopResourcesLoading || this.shopResourcesError) return
      this.brandCategoryKeyword = ''
      this.brandCategoryFilter = { one: '', two: '', three: '', config: '' }
      this.brandCategorySelection = []
      this.brandCategoryPage = 1
      this.brandCategoryPageSize = 50
      this.brandCategoryRows = []
      this.brandCategoryShow = true
      this.loadBrandCategoryRows()
    },
    closeBrandCategoryDialog() {
      this.brandCategoryShow = false
      this.brandCategorySelection = []
      ++this.brandCategoryBatchRequestId
      this.brandCategoryBatchLoading = false
      this.brandCategoryBatchMode = ''
      this.brandCategoryBatchActiveId = ''
    },
    async loadBrandCategoryRows() {
      if (!this.brandCategoryShow) return
      const requestId = ++this.brandCategoryRequestId
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.brandCategoryLoading = true
      this.brandCategoryError = ''
      try {
        const res = await getBlindBoxShopSelectedCategories(this.currentShop.mer_shop_id, { kind: 'brand', all: 1 })
        if (!this.brandCategoryShow || requestId !== this.brandCategoryRequestId || !this.isCurrentDouyinEdit(editRequestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res?.data?.list)) throw new Error(res?.message || '已配置类目加载失败')
        this.brandCategoryRows = res.data.list
        this.brandCategoryPage = 1
      } catch (error) {
        if (this.brandCategoryShow && requestId === this.brandCategoryRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.brandCategoryError = error?.message || '已配置类目加载失败，请重试'
      } finally {
        if (requestId === this.brandCategoryRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.brandCategoryLoading = false
      }
    },
    onBrandCategorySelectionChange(rows) {
      this.brandCategorySelection = rows || []
    },
    clearBrandCategorySelection() {
      if (this.$refs.brandCategoryTable) this.$refs.brandCategoryTable.clearSelection()
      this.brandCategorySelection = []
    },
    isBrandCategoryPending(row) {
      return !!this.brandCategoryPendingKeySet[String(row.id)]
    },
    isBrandCategoryConfigured(row) {
      const key = String(row.id)
      return !this.brandRemoved[key] && !!this.selectedBrandValue(row)
    },
    readCurrentPageNewBrands() {
      return this.readCurrentPageBrands('new')
    },
    readCurrentPageSavedBrands() {
      return this.readCurrentPageBrands('saved')
    },
    async readCurrentPageBrands(mode) {
      if (this.brandCategoryBatchLoading || this.brandCategoryLoading || this.brandCategoryError || !this.brandCategoryShow) return
      const rows = (mode === 'new' ? this.brandCategoryPageNewUnconfiguredRows : this.brandCategoryPageSavedRows).slice()
      if (!rows.length) return
      const editsAtStart = new Map(rows.map(row => [String(row.id), this.brandEdits[String(row.id)]]))
      const requestId = ++this.brandCategoryBatchRequestId
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      const isCurrent = () => requestId === this.brandCategoryBatchRequestId && this.brandCategoryShow && this.isCurrentDouyinEdit(editRequestId, shopId)
      this.brandCategoryBatchLoading = true
      this.brandCategoryBatchMode = mode
      let configured = 0
      let failed = 0
      try {
        for (const row of rows) {
          if (!isCurrent()) return
          const key = String(row.id)
          if (this.brandRemoved[key] || this.brandEdits[key] !== editsAtStart.get(key) || (mode === 'new'
            ? !this.brandAdded[key] || !!this.selectedBrandValue(row)
            : this.isBrandCategoryPending(row))) continue
          this.brandCategoryBatchActiveId = key
          try {
            const res = await getShopBrandList({ shop_id: shopId, category_head_id: row.id })
            if (!isCurrent()) return
            const first = res?.data?.[0]
            const brandName = first?.name_cn || first?.brand_name || first?.name_en
            const brandId = Number(first?.brand_id)
            if (res?.code !== 200 || !Array.isArray(res.data) || !Number.isSafeInteger(brandId) || brandId <= 0 || typeof brandName !== 'string' || !brandName.trim()) {
              throw new Error(res?.message || '品牌列表为空或格式异常')
            }
            this.$set(this.brandOptions, key, res.data)
            if (this.brandRemoved[key] || this.brandEdits[key] !== editsAtStart.get(key) || (mode === 'new'
              ? !this.brandAdded[key] || !!this.selectedBrandValue(row)
              : this.isBrandCategoryPending(row))) continue
            this.$set(this.brandEdits, key, { brand_id: first.brand_id, brand_name: brandName })
            configured++
          } catch {
            if (!isCurrent()) return
            failed++
          } finally {
            if (requestId === this.brandCategoryBatchRequestId && this.brandCategoryBatchActiveId === key) this.brandCategoryBatchActiveId = ''
          }
        }
        if (isCurrent()) this.$message[failed ? 'warning' : 'success'](`${mode === 'new' ? '已配置' : '已更新'} ${configured} 项，读取失败 ${failed} 项`)
      } finally {
        if (requestId === this.brandCategoryBatchRequestId) {
          this.brandCategoryBatchLoading = false
          this.brandCategoryBatchMode = ''
          this.brandCategoryBatchActiveId = ''
        }
      }
    },
    onBrandCategoryPageChange(page) {
      if (this.brandCategoryBatchLoading) return
      this.brandCategoryPage = page
    },
    onBrandCategoryPageSizeChange(size) {
      if (this.brandCategoryBatchLoading) return
      this.brandCategoryPageSize = size
      this.brandCategoryPage = 1
    },
    notifyBlockedBrandCategoryPagination(event) {
      if (!this.brandCategoryBatchLoading) return
      const sizes = event.currentTarget.parentElement.querySelector('.el-pagination__sizes')
      const bounds = sizes?.getBoundingClientRect()
      const isPageSize = event.type === 'click' && bounds && event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom
      this.$message.warning(isPageSize
        ? '正在读取本页类目品牌，请完成后再调整每页显示数量'
        : '正在读取本页类目品牌，请完成后再翻页')
    },
    searchBrandCategories() {
      this.brandCategoryPage = 1
    },
    onBrandCategoryFilterChange() {
      this.brandCategoryPage = 1
    },
    onBrandCategoryOneChange() {
      this.brandCategoryFilter.two = ''
      this.brandCategoryFilter.three = ''
      this.brandCategoryPage = 1
    },
    onBrandCategoryTwoChange() {
      this.brandCategoryFilter.three = ''
      this.brandCategoryPage = 1
    },
    removeSelectedBrandCategories() {
      const rows = this.brandCategorySelection.slice()
      if (!rows.length) return
      rows.forEach(row => {
        const key = String(row.id)
        if (this.brandAdded[key]) {
          this.$delete(this.brandAdded, key)
          this.$delete(this.brandEdits, key)
        } else if (!this.brandRemoved[key]) {
          this.$set(this.brandRemoved, key, true)
        }
      })
      this.clearBrandCategorySelection()
    },
    async loadSelectedCategories() {
      if (!this.selectedCategoryShow) return
      const requestId = ++this.selectedCategoryRequestId
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      const kind = this.selectedCategoryKind
      this.selectedCategoryLoading = true
      this.selectedCategoryError = ''
      try {
        const res = await getBlindBoxShopSelectedCategories(this.currentShop.mer_shop_id, { kind, all: 1 })
        if (!this.selectedCategoryShow || requestId !== this.selectedCategoryRequestId || !this.isCurrentDouyinEdit(editRequestId, shopId) || kind !== this.selectedCategoryKind) return
        if (res?.code !== 200 || !Array.isArray(res?.data?.list)) throw new Error(res?.message || '已选类目加载失败')
        this.selectedCategoryRows = res.data.list
        this.selectedCategoryPage = 1
      } catch (error) {
        if (this.selectedCategoryShow && requestId === this.selectedCategoryRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.selectedCategoryError = error?.message || '已选类目加载失败，请重试'
      } finally {
        if (requestId === this.selectedCategoryRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.selectedCategoryLoading = false
      }
    },
    openBrandCandidates() {
      if (!this.shopStrategyId || this.shopStrategyDetailLoading || this.shopStrategyDetailError ||
        this.categorySummaryLoading || this.categorySummaryError || this.shopResourcesLoading || this.shopResourcesError) return
      this.brandCandidatesKeyword = ''
      this.brandCandidateFilter = { one: '', two: '', three: '' }
      this.brandCandidateOptions = { one: [], two: [], three: [] }
      this.brandCandidateOptionsLoading = { one: false, two: false, three: false }
      this.brandCandidateOptionsError = ''
      this.brandCandidateOptionsErrorLevel = 0
      this.brandCandidatesSelected = []
      this.brandCandidatesAdding = false
      this.brandCandidatesPageSize = 50
      this.brandCandidatesRows = []
      this.brandCandidatesTotal = 0
      this.brandCandidatesError = ''
      this.brandCandidatesShow = true
      if (this.shopPublishCategoryIds.length) {
        this.loadBrandCandidateOptions(1)
        this.loadBrandCandidates(1)
      }
    },
    closeBrandCandidates() {
      this.brandCandidatesShow = false
      this.brandCandidatesSelected = []
      this.brandCandidatesAdding = false
      Object.keys(this.brandCandidateOptionsRequestId).forEach(key => { ++this.brandCandidateOptionsRequestId[key] })
    },
    searchBrandCandidates() {
      this.loadBrandCandidates(1)
    },
    async loadBrandCandidateOptions(level, parentId = 0) {
      const key = level === 1 ? 'one' : (level === 2 ? 'two' : 'three')
      const requestId = (this.brandCandidateOptionsRequestId[key] || 0) + 1
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.brandCandidateOptionsRequestId[key] = requestId
      this.brandCandidateOptionsLoading[key] = true
      this.brandCandidateOptionsError = ''
      this.brandCandidateOptionsErrorLevel = 0
      try {
        const res = await getBlindBoxShopBrandCandidateCategories(this.currentShop.mer_shop_id, { level, parent_id: parentId })
        if (!this.brandCandidatesShow || requestId !== this.brandCandidateOptionsRequestId[key] || !this.isCurrentDouyinEdit(editRequestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res?.data)) throw new Error(res?.message || '类目选项加载失败')
        this.$set(this.brandCandidateOptions, key, res.data)
      } catch (error) {
        if (this.brandCandidatesShow && requestId === this.brandCandidateOptionsRequestId[key] && this.isCurrentDouyinEdit(editRequestId, shopId)) {
          this.brandCandidateOptionsError = error?.message || '类目选项加载失败，请重试'
          this.brandCandidateOptionsErrorLevel = level
        }
      } finally {
        if (requestId === this.brandCandidateOptionsRequestId[key] && this.isCurrentDouyinEdit(editRequestId, shopId)) this.brandCandidateOptionsLoading[key] = false
      }
    },
    retryBrandCandidateOptions() {
      const level = this.brandCandidateOptionsErrorLevel || 1
      const parentId = level === 1 ? 0 : (level === 2 ? this.brandCandidateFilter.one : this.brandCandidateFilter.two)
      this.loadBrandCandidateOptions(level, parentId || 0)
    },
    onBrandCandidateOneChange(value) {
      this.brandCandidateFilter.two = ''
      this.brandCandidateFilter.three = ''
      this.brandCandidateOptions.two = []
      this.brandCandidateOptions.three = []
      if (value) this.loadBrandCandidateOptions(2, value)
      this.loadBrandCandidates(1)
    },
    onBrandCandidateTwoChange(value) {
      this.brandCandidateFilter.three = ''
      this.brandCandidateOptions.three = []
      if (value) this.loadBrandCandidateOptions(3, value)
      this.loadBrandCandidates(1)
    },
    onBrandCandidateThreeChange() {
      this.loadBrandCandidates(1)
    },
    async loadBrandCandidates(page = 1) {
      if (!this.brandCandidatesShow) return
      const requestId = ++this.brandCandidatesRequestId
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.brandCandidatesLoading = true
      this.brandCandidatesError = ''
      this.brandCandidatesRows = []
      this.brandCandidatesTotal = 0
      try {
        const res = await getBlindBoxShopBrandCandidates(this.currentShop.mer_shop_id, {
          page,
          page_size: this.brandCandidatesPageSize,
          keyword: this.brandCandidatesKeyword,
          category_one_id: this.brandCandidateFilter.one || 0,
          category_two_id: this.brandCandidateFilter.two || 0,
          category_three_id: this.brandCandidateFilter.three || 0,
        })
        if (!this.brandCandidatesShow || requestId !== this.brandCandidatesRequestId || !this.isCurrentDouyinEdit(editRequestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res?.data?.list)) throw new Error(res?.message || '候选类目加载失败')
        if (Number(res.data.strategy_id) !== this.shopStrategyId) throw new Error('店铺绑定的盲盒策略已变化，请重新打开店铺资源弹窗')
        const allowedIds = new Set(this.shopPublishCategoryIds)
        if (res.data.list.some(row => !allowedIds.has(String(row.category_two_id)))) throw new Error('策略上货类目已变化，请重新打开店铺资源弹窗')
        this.brandCandidatesRows = res.data.list
        this.brandCandidatesTotal = Number(res.data.total) || 0
        this.brandCandidatesPage = Number(res.data.page) || page
        if (Number(res.data.page_size) > 0) this.brandCandidatesPageSize = Number(res.data.page_size)
      } catch (error) {
        if (this.brandCandidatesShow && requestId === this.brandCandidatesRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.brandCandidatesError = error?.message || '候选类目加载失败，请重试'
      } finally {
        if (requestId === this.brandCandidatesRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.brandCandidatesLoading = false
      }
    },
    isBrandCategorySelected(id) {
      const key = String(id)
      return Boolean(this.brandAdded[key] || (this.brandKeyValues_def[key] && !this.brandRemoved[key]))
    },
    isBrandCandidateSelectable(row) {
      return this.shopPublishCategoryIds.includes(String(row.category_two_id)) && !this.isBrandCategorySelected(row.id)
    },
    onBrandCandidatesSelectionChange(rows) {
      this.brandCandidatesSelected = rows || []
    },
    clearBrandCandidatesSelection() {
      if (this.$refs.brandCandidatesTable) this.$refs.brandCandidatesTable.clearSelection()
      this.brandCandidatesSelected = []
    },
    async batchAddBrandCategories() {
      if (this.brandCandidatesAdding || this.brandCandidatesLoading || this.brandCandidatesError || !this.brandCandidatesShow) return
      const rows = this.brandCandidatesSelected.slice()
      if (!rows.length) return
      const requestId = ++this.brandCandidatesAddRequestId
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.brandCandidatesAdding = true
      try {
        const res = await getBlindBoxShopSelectedCategories(this.currentShop.mer_shop_id, { kind: 'publish', all: 1 })
        if (!this.brandCandidatesShow || requestId !== this.brandCandidatesAddRequestId || !this.isCurrentDouyinEdit(editRequestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res?.data?.list)) throw new Error(res?.message || '当前策略类目校验失败，请重试')
        if (Number(res.data.strategy_id) !== this.shopStrategyId) throw new Error('店铺绑定的盲盒策略已变化，请重新打开店铺资源弹窗')
        const currentIds = res.data.list.filter(row => row.valid).map(row => String(row.id))
        const currentSet = new Set(currentIds)
        if (currentSet.size !== this.shopPublishCategoryIds.length || this.shopPublishCategoryIds.some(id => !currentSet.has(id))) {
          this.shopPublishCategoryIds = currentIds
          this.clearBrandCandidatesSelection()
          this.brandCandidateFilter = { one: '', two: '', three: '' }
          this.brandCandidateOptions = { one: [], two: [], three: [] }
          if (currentIds.length) {
            this.loadBrandCandidateOptions(1)
            this.loadBrandCandidates(1)
          } else {
            this.brandCandidatesRows = []
            this.brandCandidatesTotal = 0
          }
          throw new Error('盲盒策略的上货类目已变化，候选已刷新，请重新选择')
        }
        if (rows.some(row => !currentSet.has(String(row.category_two_id)))) throw new Error('所选类目不属于当前盲盒策略，请重新选择')
        rows.forEach(row => {
          const key = String(row.id)
          if (this.brandRemoved[key]) this.$delete(this.brandRemoved, key)
          else if (!this.brandKeyValues_def[key]) this.$set(this.brandAdded, key, row)
        })
        this.closeBrandCandidates()
        if (!this.brandCategoryShow) this.openBrandCategoryDialog()
      } catch (error) {
        if (this.brandCandidatesShow && requestId === this.brandCandidatesAddRequestId && this.isCurrentDouyinEdit(editRequestId, shopId)) this.$message.error(error?.message || '添加类目品牌失败，请重试')
      } finally {
        if (requestId === this.brandCandidatesAddRequestId) this.brandCandidatesAdding = false
      }
    },
    removeBrandCategory(row) {
      const key = String(row.id)
      if (this.brandAdded[key]) {
        this.$delete(this.brandAdded, key)
        this.$delete(this.brandEdits, key)
      } else if (this.brandRemoved[key]) this.$delete(this.brandRemoved, key)
      else this.$set(this.brandRemoved, key, true)
    },
    selectedBrandValue(row) {
      const key = String(row.id)
      const brand = this.brandEdits[key] || this.brandKeyValues_def[key] || (row.brand_id ? { brand_id: row.brand_id, brand_name: row.brand_name } : null)
      return brand?.brand_id == null ? '' : String(brand.brand_id)
    },
    brandOptionsFor(row) {
      const key = String(row.id)
      const options = this.brandOptions[key] || []
      const currentId = this.selectedBrandValue(row)
      if (!currentId || options.some(item => String(item.brand_id) === currentId)) return options
      const brand = this.brandEdits[key] || this.brandKeyValues_def[key] || row
      return [{ brand_id: currentId, brand_name: brand.brand_name || '已配置品牌' }, ...options]
    },
    async loadBrandOptions(id) {
      const key = String(id)
      if (this.brandOptions[key] || this.brandOptionsLoading[key]) return
      const editRequestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.$set(this.brandOptionsLoading, key, true)
      try {
        const res = await getShopBrandList({ shop_id: shopId, category_head_id: id })
        if (!this.isCurrentDouyinEdit(editRequestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res.data)) throw new Error(res?.message || '品牌加载失败')
        this.$set(this.brandOptions, key, res.data)
      } catch (error) {
        if (this.isCurrentDouyinEdit(editRequestId, shopId)) this.$message.error(error?.message || '品牌加载失败')
      } finally {
        if (this.isCurrentDouyinEdit(editRequestId, shopId)) this.$set(this.brandOptionsLoading, key, false)
      }
    },
    setSelectedBrand(row, brandId) {
      const brand = this.brandOptionsFor(row).find(item => String(item.brand_id) === String(brandId))
      if (brand) this.$set(this.brandEdits, String(row.id), { brand_id: brand.brand_id, brand_name: brand.name_cn || brand.brand_name })
    },
    wechatLevelOptions(rows, selectedOne) {
      const one = new Map()
      const two = new Map()
      rows.forEach(row => {
        if (!row.valid || row.path_ids.length < 2) return
        const oneKey = String(row.path_ids[0])
        if (!one.has(oneKey)) one.set(oneKey, { id: row.path_ids[0], name: row.path_names[0] || oneKey })
        if (selectedOne && String(selectedOne) !== oneKey) return
        const twoKey = String(row.path_ids[1])
        if (!two.has(twoKey)) two.set(twoKey, { id: row.path_ids[1], name: row.path_names[1] || twoKey })
      })
      return { one: [...one.values()], two: [...two.values()] }
    },
    wechatBrandValue(brand) {
      const id = brand?.brand_id
      return id !== null && id !== undefined && String(id) !== '' && Number(id) > 0 ? String(id) : ''
    },
    wechatBrandName(brand) {
      return brand?.name_cn || brand?.brand_name || ''
    },
    wechatBrandInShopList(brand) {
      return this.wShopBrandList.some(item => String(item.brand_id) === String(brand?.brand_id))
    },
    setWechatCategoryBrand(row, brandId) {
      if (!row.valid || !row.source) return
      if (!brandId) {
        row.source.brand = null
      } else {
        const brand = this.wShopBrandList.find(item => String(item.brand_id) === String(brandId))
        if (brand) row.source.brand = brand
      }
      this.$nextTick(() => {
        const maxPage = Math.max(1, Math.ceil(this.wechatBrandFilteredRows.length / this.wechatBrandPageSize))
        if (this.wechatBrandPage > maxPage) this.wechatBrandPage = maxPage
      })
    },
    openWechatCategoryDialog() {
      if (!this.wechatStrategyLoaded || !this.wechatCategoriesLoaded) return
      this.wechatCategoryFilter = { one: '', two: '' }
      this.wechatCategoryPage = 1
      this.wechatCategoryPageSize = 50
      this.wechatCategoryDialogShow = true
    },
    onWechatCategoryOneChange() {
      this.wechatCategoryFilter.two = ''
      this.wechatCategoryPage = 1
    },
    onWechatCategoryPageSizeChange(size) {
      this.wechatCategoryPageSize = size
      this.wechatCategoryPage = 1
    },
    openWechatBrandDialog() {
      if (!this.wechatStrategyLoaded || !this.wechatResourcesLoaded || !this.wechatCategoriesLoaded) return
      this.wechatBrandKeyword = ''
      this.wechatBrandFilter = { one: '', two: '', config: '' }
      this.wechatBrandPage = 1
      this.wechatBrandPageSize = 50
      this.wechatBrandDialogShow = true
    },
    onWechatBrandOneChange() {
      this.wechatBrandFilter.two = ''
      this.wechatBrandPage = 1
    },
    onWechatBrandPageSizeChange(size) {
      this.wechatBrandPageSize = size
      this.wechatBrandPage = 1
    },
    openWechatEdit(shop) {
      const requestId = this.shopEditRequestId
      this.editType = 'wechat'
      this.editShow = true
      const strategyId = Number(shop.blind_box_strategy_id || shop.blind_box_strategy?.id)
      this.shopStrategyId = Number.isInteger(strategyId) && strategyId > 0 ? strategyId : null
      this.wechatStrategyLoading = false
      this.wechatStrategyError = ''
      this.wechatStrategyLoaded = !this.shopStrategyId
      this.wechatStrategyConfig = null
      this.wechatResourcesLoading = false
      this.wechatResourcesError = ''
      this.wechatResourcesLoaded = false
      this.wechatCategoryLoading = false
      this.wechatCategoryError = ''
      this.wechatCategoriesLoaded = false
      this.wechatEffectiveCategoryIds = []
      this.wechatMissingCategoryIds = []
      this.wechatStaleBrandKeys = []
      this.wechatBrandSnapshot = {}
      this.wechatChildGroups = []
      this.wForm = {
        shop_limit_price: null, strategies_id: '', freight_template_id: '', freight_insurance: false,
        shop_product_repository_skus: [], shop_product_repository_groups: [],
        shop_product_repository_child_groups: [], daily_num: null, return_address_id: ''
      }
      this.cloudGroupList = []
      this.wCateList = []
      this.wCateTableData = []
      this.wSelectedCateIds = []
      this.wSelectedCateList = []
      this.wShopBrandList = []
      this.wReturnAddressList = []
      this.freightTemplate = []
      this.wechatCategoryDialogShow = false
      this.wechatBrandDialogShow = false
      this.expandedW = {}
      this.loadCloudGroupList()
      this.loadWechatCategories(requestId, shop.shop_id)
      this.loadWechatResources(requestId, shop.shop_id)
      if (this.shopStrategyId) this.loadWechatStrategy(requestId, shop.shop_id)
    },
    isCurrentWechatEdit(requestId, shopId) {
      return this.editShow && this.editType === 'wechat' &&
        this.shopEditRequestId === requestId && String(this.currentShop.shop_id) === String(shopId)
    },
    applyWechatSharedConfig(config) {
      this.wForm.shop_limit_price = config.shop_limit_price ?? null
      this.wForm.strategies_id = config.strategies_id ? Number(config.strategies_id) : ''
      this.wForm.shop_product_source = 2
      this.wForm.shop_product_repository_skus = (Array.isArray(config.shop_product_repository_skus) ? config.shop_product_repository_skus : []).map(Number)
      this.wForm.shop_product_repository_groups = (Array.isArray(config.shop_product_repository_groups) ? config.shop_product_repository_groups : []).map(Number)
      this.wForm.shop_product_repository_child_groups = (Array.isArray(config.shop_product_repository_child_groups) ? config.shop_product_repository_child_groups : []).map(Number)
      this.wForm.daily_num = config.daily_num ?? null
      this.wechatEffectiveCategoryIds = Array.from(new Set(String(config.categoryIds || '').split(',').map(id => id.trim()).filter(Boolean)))
      this.loadWechatChildGroups()
      this.syncWechatCategoryRows()
    },
    loadWechatChildGroups() {
      const parentIds = this.wForm.shop_product_repository_groups
      if (!parentIds.length) {
        this.wechatChildGroups = []
        return
      }
      const requestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.getCloudProductGroupsNew({
        data: { page: 1, page_size: 5000, parent_ids: parentIds },
        success: (res) => {
          if (this.isCurrentWechatEdit(requestId, shopId) && res.code === 200) this.wechatChildGroups = res.data?.list || []
        }
      })
    },
    async loadWechatStrategy(requestId, shopId) {
      const strategyId = this.shopStrategyId
      if (!strategyId) return
      this.wechatStrategyLoading = true
      this.wechatStrategyError = ''
      try {
        const res = await getBlindBoxStrategy(strategyId)
        if (!this.isCurrentWechatEdit(requestId, shopId) || this.shopStrategyId !== strategyId) return
        if (res?.code !== 200 || Number(res.data?.id) !== strategyId || Number(res.data?.shop_type) !== 7 || !res.data?.config) {
          throw new Error(res?.message || '当前盲盒策略加载失败')
        }
        this.applyWechatSharedConfig(res.data.config)
        this.wechatStrategyConfig = res.data.config
        this.wechatStrategyLoaded = true
        this.syncWechatCategoryRows()
      } catch (error) {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatStrategyError = error?.message || '当前盲盒策略加载失败，请重试'
      } finally {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatStrategyLoading = false
      }
    },
    retryWechatStrategy() {
      if (this.shopStrategyId && !this.wechatStrategyLoading) this.loadWechatStrategy(this.shopEditRequestId, this.currentShop.shop_id)
    },
    async loadWechatResources(requestId, shopId) {
      this.wechatResourcesLoading = true
      this.wechatResourcesError = ''
      try {
        const res = await blindBoxDetail({ shop_id: shopId, shop_type: 7 })
        if (!this.isCurrentWechatEdit(requestId, shopId)) return
        if (res?.code !== 200 || !res.data) throw new Error(res?.message || '店铺资源加载失败')
        const data = res.data
        this.strategiesList = Array.isArray(data.strategies_list) ? data.strategies_list : []
        if (!Array.isArray(data.shop_freight_template_list) || !Array.isArray(data.shop_return_address_list)) throw new Error('运费模板或售后地址列表响应异常')
        this.freightTemplate = data.shop_freight_template_list.map(item => item?.template || item)
          .filter(item => item && item.id !== null && item.id !== undefined && item.template_name)
        this.maxAutoNum = Number(data.max_auto_num) || 0
        this.wShopBrandList = Array.isArray(data.shop_brand_list) ? data.shop_brand_list : []
        this.wReturnAddressList = data.shop_return_address_list
          .filter(item => item && item.address_id !== null && item.address_id !== undefined)
          .map(item => ({ ...item, address_id: String(item.address_id) }))
        this.wForm.freight_template_id = data.shop_freight_template_id === null || data.shop_freight_template_id === undefined ? '' : String(data.shop_freight_template_id)
        this.wForm.freight_insurance = Number(data.freight_insurance) === 1
        this.wForm.return_address_id = data.return_address_id !== null && data.return_address_id !== undefined && String(data.return_address_id) !== '' && String(data.return_address_id) !== '0'
          ? String(data.return_address_id) : this.wReturnAddressList[0]?.address_id || ''
        this.defaultNum = Number(data.default_num) || 0
        this.wechatBrandSnapshot = data.brandKeyValues && typeof data.brandKeyValues === 'object' && !Array.isArray(data.brandKeyValues)
          ? JSON.parse(JSON.stringify(data.brandKeyValues)) : {}
        if (!this.shopStrategyId) this.applyWechatSharedConfig(data)
        this.wechatResourcesLoaded = true
        this.syncWechatCategoryRows()
      } catch (error) {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatResourcesError = error?.message || '店铺资源加载失败，请重试'
      } finally {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatResourcesLoading = false
      }
    },
    retryWechatResources() {
      if (!this.wechatResourcesLoading) this.loadWechatResources(this.shopEditRequestId, this.currentShop.shop_id)
    },
    async loadWechatCategories(requestId, shopId) {
      this.wechatCategoryLoading = true
      this.wechatCategoryError = ''
      try {
        const res = await wechatCategoryList({ shop_id: shopId })
        if (!this.isCurrentWechatEdit(requestId, shopId)) return
        if (res?.code !== 200 || !Array.isArray(res.data)) throw new Error(res?.message || '微信店铺授权类目加载失败')
        this.leafToSecondCateMap = this.buildLeafToSecondCateMap(res.data)
        this.wCateList = this.buildSecondLevelCateTree(res.data)
        this.wCateTableData = this.flattenCateTree(this.wCateList)
        if (!this.wCateTableData.length) this.wechatCategoryError = '微信店铺没有可用的二级类目'
        this.wechatCategoriesLoaded = true
        this.syncWechatCategoryRows()
      } catch (error) {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatCategoryError = error?.message || '微信店铺授权类目加载失败，请重试'
      } finally {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.wechatCategoryLoading = false
      }
    },
    retryWechatCategories() {
      if (!this.wechatCategoryLoading) this.loadWechatCategories(this.shopEditRequestId, this.currentShop.shop_id)
    },
    syncWechatCategoryRows() {
      if (!this.wechatStrategyLoaded || !this.wechatResourcesLoaded || !this.wechatCategoriesLoaded) return
      const secondIds = Array.from(new Set(this.wechatEffectiveCategoryIds.map(id => String(this.getSecondCategoryId(id)))))
      const selectedIds = new Set(secondIds)
      const configuredBrands = {}
      const currentBrands = new Map(this.wSelectedCateList.map(item => [String(item.category_id), item.brand]))
      Object.entries(this.wechatBrandSnapshot).forEach(([key, brand]) => {
        const secondId = String(this.getSecondCategoryId(key))
        if (selectedIds.has(secondId) && !configuredBrands[secondId]) configuredBrands[secondId] = brand
      })
      this.wechatStaleBrandKeys = Object.keys(this.wechatBrandSnapshot).filter(key => !selectedIds.has(String(this.getSecondCategoryId(key))))
      this.wSelectedCateList = this.wCateTableData.filter(item => selectedIds.has(String(item.category_id))).map(item => ({
        ...item,
        brand: currentBrands.has(String(item.category_id)) ? currentBrands.get(String(item.category_id)) : configuredBrands[String(item.category_id)] || null,
        limit_num: this.defaultNum
      }))
      const foundIds = new Set(this.wSelectedCateList.map(item => String(item.category_id)))
      this.wechatMissingCategoryIds = secondIds.filter(id => !foundIds.has(id))
      this.wSelectedCateIds = this.wSelectedCateList.map(item => item.cate_path)
      this.wSelectedCateIds.forEach(path => {
        if (path[0]) this.$set(this.expandedW, path[0], true)
      })
    },
    /**
     *  ── 抖店分类/品牌 ── */
    //类目数据格式化
    formatCategory(list){
      if(list.length){
        list.forEach(item=>{
          if(item?.sub_category?.length){
            this.formatCategory(item.sub_category)
          }else{
            delete item.sub_category
          }
        })
      }
    },
    //类目回显
    setSelCate(ids,cate,selList,idArr){
      idArr.push(cate.category_id)
      if(cate?.sub_category?.length){
        cate.sub_category.forEach(item=>{
          // 传入副本，避免兄弟节点递归时污染已记录的路径
          this.setSelCate(ids,item,selList,[...idArr])
        })
      }else if(ids.has(String(cate.category_id))){
        selList.push(idArr)
      }
    },
    //一级、二级类目选择
    changeCateCascader(init){
      if (!init&&this.currentShop.shop_product_source==1&&this.selCate?.length > 20) {
        // 移除最后一个选择的项，以保持不超过 maxSelections 个选项
        this.$message.warning('最多只能选择 20 个选项，请进行删减');
      }
      if(!this.selCate||!this.selCate.length){
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.subCateBrand={}
        this.getCateBrand(false)
      }
    },
    removeCateCascader(e){
      let arr = this.selCate.filter(item=>item[0]!=e[0]||(item[0]==e[0]&&item[1]!=e[1]))
      this.selCate = arr
      this.cateRandom = Math.random()
      if(!arr.length) {
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.subCateBrand={}
        this.getCateBrand(false)
        return false
      }
      this.getTwoCategorySubList()
    },
    blurCateCascader(e){
      if(e) return
      this.getTwoCategorySubList()
    },
    //获取二级类目下级叶子类目
    getTwoCategorySubList(init) {
      const arr = this.selCate.map(item => item[1])
      if (!arr.length) {
        this.selCateSubOptions = []
        return false
      }
      const ids = arr.join(',')
      const requestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.opGetTwoCategorySubList({
        data: { category_two_ids: ids },
        success: (res) => {
          if (!this.isCurrentDouyinEdit(requestId, shopId)) return
          if (res.code === 200) {
            this.selCateSubOptions = res.data || []
            if (init) {
              const keys = Object.keys(this.brandKeyValues_def)
              this.selCateSub = this.selCateSubOptions.filter(i => keys.includes(String(i.category_id)))
              this.getCateBrand(true)
            } else {
              const optionIdArr = this.selCateSubOptions.map(item => String(item.category_id))
              this.selCateSub = this.selCateSub.filter(i => optionIdArr.includes(String(i.category_id)))
              const brandCateIdArr = Object.keys(this.subCateBrand)
              const delCataIdArr = brandCateIdArr.filter(item => !optionIdArr.includes(String(item)))
              delCataIdArr.forEach(item => {
                delete this.subCateBrand[item]
              })
            }
          }
        }
      })
    },

    //子（三）级类目(即品牌类目)选择——全选
    changeCateSubCheckAll(val){
      this.selCateSub = val?this.selCateSubOptions:[]
      this.isIndeterminate=false
    },
    //子（三）级类目(即品牌类目)选择
    changeCateSub(){
      this.cateSubAllChecked = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length
      if(!this.selCateSub.length){
        this.brandLoading =false
        this.subCateBrand={}
      }
    },
    removeCateSub(e){
      if(!this.brandLoading){
        delete this.subCateBrand[e.category_id]
        this.brandRandom  =Math.random()
      }else{
        this.removeCateIds.push(e.category_id)
        this.brandLoading =false
        this.getCateBrand(false)
      }
    },

    //品牌类目下的品牌
    async getCateBrand(e,init) {
      this.brandLoading = false
      if(e) return false
      try {
        this.brandLoading = true
        if (!this.selCateSub.length){
          this.subCateBrand={}
          this.brandLoading = false
          return
        }
        //新已选类目ID数组
        const selCateIdArr =this.selCateSub.map(item=>item.category_id)
        //已缓存的类目品牌的类目ID
        const ycCateIdArr=Object.keys(this.brandObjCache)
        //待缓存的类目ID
        const addCateIdArr = selCateIdArr.filter(item=>!ycCateIdArr.includes(String(item)))

        //更新已选类目对应的品牌
        Object.keys(this.subCateBrand).forEach(item => {
          if (!selCateIdArr.includes(item)) delete this.subCateBrand[item]
        })

        for (var item of this.selCateSub){
          if(!this.brandLoading){
            if(!this.selCateSub.length){
              this.subCateBrand={}
            }
            break;
          }
          if(!ycCateIdArr.includes(String(item.category_id))){
            this.$set(this.brandListLoading,item.category_id,true)
          }
          let obj={}
          if(!this.subCateBrand[item.category_id]){
            const defaultBrand = this.brandObjCache[item.category_id]&&this.brandObjCache[item.category_id].length===1?this.brandObjCache[item.category_id][0]:null
            obj = {
              category_id: item.category_id,
              category_name: item.path_names,
              // brand:this.brandKeyValues_def[item.category_id],
              brand:this.brandKeyValues_def[item.category_id]||defaultBrand,
            }
          }
          this.subCateBrand[item.category_id]=obj
          this.brandRandom  =Math.random()
        }

        //获取未缓存的类目品牌
        for(var j=1;j<=Math.ceil(addCateIdArr.length/10);j++){
          if(!this.brandLoading){
            addCateIdArr.forEach(item=>{
              this.$set(this.brandListLoading,item,false)
            })
            break;
          }
          let ids = addCateIdArr.slice((j-1)*10,j*10)
          let res = await this.getBrandListBatch(ids)
          let list = res.list
          this.brandObjCache=Object.assign(list,this.brandObjCache)
          ids.forEach(item=>{
            this.$set(this.brandListLoading,item,false)
            if((!init||(init&&(!this.subCateBrand[item].brand||!this.subCateBrand[item].brand.brand_id)))&&this.brandObjCache[item].length===1){
              this.subCateBrand[item].brand = this.brandObjCache[item][0]
            }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      }finally {
        if(this.removeCateIds.length){
          for(var key of this.removeCateIds){
            delete this.subCateBrand[key]
          }
          this.brandRandom  =Math.random()
          this.removeCateIds=[]
        }
        this.selCateOld=[...this.selCate]
        this.brandLoading =false
      }

    },
    getBrandList(id) {
      return new Promise((resolve) => {
        this.$set(this.brandListLoading, id, true)
        this.fetchBrandList({
          data: { shop_id: this.currentShop.shop_id, category_head_id: id },
          success: (res) => {
            this.$set(this.brandListLoading, id, false)
            if (res.code === 200) {
              this.brandObjCache[id] = res.data
              resolve(res.data)
            } else {
              this.$message.error(res.message)
              resolve([])
            }
          }
        })
      })
    },
    getBrandListBatch(ids) {
      return new Promise((resolve) => {
        this.fetchBrandListBatch({
          data: { shop_type: this.searchData.shop_type, shop_id: this.currentShop.shop_id, category_ids: ids.join(',') },
          success: (res) => {
            if (res.code === 200) resolve(res.data)
            else {
              this.$message.error(res.message)
              resolve({})
            }
          }
        })
      })
    },
    changeSubCateBrand(e,id){
      this.brandRandom=Math.random()
      const name =this.subCateBrand[id].brand.name_cn||this.subCateBrand[id].brand.brand_name
      this.$set(this.subCateBrand[id],'new_brand_name',name)
    },

    //一键清除无品牌
    clearNotBrand() {
      const idArr =Object.keys(this.subCateBrand)
      let delArr=[]
      idArr.forEach(key=>{
        if(this.subCateBrand[key].brand&&(this.subCateBrand[key].brand.name_cn==='无品牌'||this.subCateBrand[key].brand.brand_name==='无品牌')){
          delArr.push(key)
          delete this.subCateBrand[key]
        }
      })

      const newSelCateSub = this.selCateSub.filter(item=>!delArr.includes(String(item.category_id)))
      this.selCateSub = newSelCateSub
      this.cateSubAllChecked = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length

    },
    /**
     *  ── 不上关键词 ── */

    searchKeyword(index) {
      const keyword = this.selSubCate[index].search
      if (!keyword) {
        this.$message.warning('请输入要搜索的关键词')
        return
      }
      this.selSubCate[index].loading = true
      this.fetchPhraseList({
        data: { title: keyword },
        success: (res) => {
          this.selSubCate[index].loading = false
          if (res.code === 200) {
            this.selSubCate[index].keyword_arr = res.data || []
            this.$message.success('请在后面的选择框中选择')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /**
     *  ── 云商品库分组 ── */
    loadCloudGroupList() {
      const requestId = ++this.cloudGroupListRequestId
      this.cloudGroupListStatus = 'loading'
      this.getCloudProductGroups({
        data: { with_count: 0, view_share: 1},
        success: (res) => {
          if (requestId !== this.cloudGroupListRequestId) return
          if (res.code === 200 && Array.isArray(res.data)) {
            this.cloudGroupList = res.data
            this.cloudGroupListStatus = 'success'
          } else {
            this.cloudGroupListStatus = 'error'
          }
        }
      })
    },
    //获取主分组下了子分组
    getGroupChilder(e,type) {
      if(e&&type==='visible') return
      if (!this.currentShop.shop_product_repository_groups || !this.currentShop.shop_product_repository_groups.length) {
        this.cloudGroupChilder = []
        this.currentShop.shop_product_repository_child_groups = []
        return
      }
      const requestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      this.getCloudProductGroupsNew({
        data: { page: 1, page_size: 100, parent_ids: this.currentShop.shop_product_repository_groups },
        success: (res) => {
          if (!this.isCurrentDouyinEdit(requestId, shopId)) return
          if (res.code === 200) {
            this.cloudGroupChilder = res?.data?.list ?? []
            const idArr = this.cloudGroupChilder.map(item => item.id)
            this.currentShop.shop_product_repository_child_groups = this.currentShop.shop_product_repository_child_groups.filter(id => idArr.includes(id))
          }
        }
      })
    },
    /**
     *  ── 保存（抖店） ── */
    saveShopSettings() {
      if (this.brandCategoryBatchLoading || this.shopStrategyDetailLoading || this.shopStrategyDetailError || this.shopResourcesLoading || this.shopResourcesError) return
      try {
        const obj_f = this.freightTemplate.find(i => i.id == this.currentShop.shop_freight_template_id)
        if (!obj_f) throw '请选择有效的运费模板'
        const brandKeyValues = JSON.parse(JSON.stringify(this.brandKeyValues_def || {}))
        for (const id of Object.keys(this.brandRemoved)) {
          if (this.brandRemoved[id]) delete brandKeyValues[id]
        }
        for (const id of Object.keys(this.brandAdded)) {
          if (!this.brandEdits[id]?.brand_id) throw '请为新增类目选择品牌'
        }
        for (const [id, brand] of Object.entries(this.brandEdits)) {
          if (!this.brandRemoved[id] && brand?.brand_id) brandKeyValues[id] = brand
        }
        const params = {
          shop_type: this.searchData.shop_type,
          shop_id: this.currentShop.shop_id,
          freight_template_id: this.currentShop.shop_freight_template_id,
          freight_template_name: obj_f.template_name,
          brandKeyValues
        }
        this.sLoading = true
        saveBlindBoxResources(params).then(res => {
          if (res.code === 200) {
            this.closeEdit()
            this.$message.success('保存成功')
            this.refreshBlindBoxList()
          } else this.$message.error(res.message || '保存失败')
        }).catch(() => this.$message.error('网络异常，保存失败')).finally(() => { this.sLoading = false })
      } catch (e) {
        this.$message.error(e)
        this.sLoading = false
      }
    },
    /**
     *  ── 微信分类 ── */
    buildSecondLevelCateTree(nodes) {
      return (nodes || []).map(item => {
        const children = (item.sub_category || []).map(second => {
          const { sub_category, ...secondCate } = second
          return { ...secondCate, is_leaf: true }
        })
        return { ...item, sub_category: children }
      }).filter(item => item.sub_category && item.sub_category.length)
    },
    buildLeafToSecondCateMap(nodes) {
      const map = {}
      const walk = (node, secondId) => {
        if (!node) return
        map[String(node.category_id)] = secondId
        ;(node.sub_category || []).forEach(child => walk(child, secondId))
      }
      ;(nodes || []).forEach(root => {
        ;(root.sub_category || []).forEach(second => walk(second, second.category_id))
      })
      return map
    },
    getSecondCategoryId(categoryId) {
      return this.leafToSecondCateMap[String(categoryId)] || categoryId
    },
    flattenCateTree(nodes, level1 = '', level2 = '', level3 = '', level1_id = null, level2_id = null, level3_id = null) {
      const result = []
      const flatten = (nodes, l1, l2, l3, l1_id, l2_id, l3_id) => {
        nodes.forEach(node => {
          if (node.is_leaf) {
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            const rowData = {
              row_key: `${node.category_id}`,
              category_id: node.category_id,
              path_names: node.path_names,
              cate_path: [l1_id, l2_id, l3_id, node.category_id].filter(id => id !== null && id !== undefined),
              level1_id: l1_id,
              level2_id: l2_id,
              level3_id: l3_id
            }
            if (depth === 2) {
              rowData.level1_name = l1
              rowData.level2_name = node.category_name
              rowData.level2_id = node.category_id
            } else {
              rowData.level1_name = l1
              rowData.level2_name = node.category_name
              rowData.level2_id = node.category_id
            }
            result.push(rowData)
          } else if (node.sub_category && node.sub_category.length) {
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            if (depth === 1) {
              flatten(node.sub_category, node.category_name, '', '', node.category_id, null, null)
            } else if (depth === 2) {
              flatten(node.sub_category, l1, node.category_name, '', l1_id, node.category_id, null)
            } else if (depth === 3) {
              flatten(node.sub_category, l1, l2, node.category_name, l1_id, l2_id, node.category_id)
            }
          }
        })
      }
      flatten(nodes, level1, level2, level3, level1_id, level2_id, level3_id)
      return result
    },
    toggleExpandW(id) {
      this.$set(this.expandedW, id, !this.expandedW[id])
    },
    isWCateSelected(l1, l2) {
      return this.wSelectedCateIds.some(path => String(path[path.length - 1]) === String(l2))
    },
    toggleWCate(l1, l2, checked) {
      const path = [l1.category_id, l2.category_id]
      if (checked) {
        if (!this.wSelectedCateIds.some(p => String(p[p.length - 1]) === String(l2.category_id))) {
          this.wSelectedCateIds.push(path)
        }
        this.$set(this.expandedW, l1.category_id, true)
      } else {
        this.wSelectedCateIds = this.wSelectedCateIds.filter(p => String(p[p.length - 1]) !== String(l2.category_id))
      }
      const secondIds = this.wSelectedCateIds.map(item => String(item[item.length - 1]))
      const oldMap = {}
      this.wSelectedCateList.forEach(item => {
        oldMap[item.category_id] = item
      })
      this.wSelectedCateList = this.wCateTableData
        .filter(item => secondIds.includes(String(item.category_id)))
        .map(item => {
          const old = oldMap[item.category_id] || {}
          return { ...item, brand: old.brand || null, limit_num: old.limit_num || this.defaultNum }
        })
    },
    removeWCate(item) {
      this.wSelectedCateIds = this.wSelectedCateIds.filter(p => String(p[p.length - 1]) !== String(item.category_id))
      this.wSelectedCateList = this.wSelectedCateList.filter(i => i.category_id != item.category_id)
    },
    // 级联类目变更后同步已选类目，保留已有品牌和关键词设置。
    changeWCateCascader(value) {
      const validPaths = value.filter(item => item.length >= 2)
      const secondIds = validPaths.map(item => String(item[item.length - 1]))
      this.wSelectedCateIds = validPaths
      const oldMap = {}
      this.wSelectedCateList.forEach(item => {
        oldMap[item.category_id] = item
      })
      this.wSelectedCateList = this.wCateTableData
          .filter(item => secondIds.includes(String(item.category_id)))
          .map(item => {
            const old = oldMap[item.category_id] || {}
            return {
              ...item,
              brand: old.brand || null,
              limit_num: old.limit_num || this.defaultNum
            }
          })
      this.brandRandom = Math.random()
    },
    /**
     *  ── 保存（微信） ── */
    async saveWechatSettings() {
      if (this.wechatSaveDisabled) {
        this.$message.error('请先绑定策略并成功加载策略、店铺资源和授权类目')
        return
      }
      const requestId = this.shopEditRequestId
      const shopId = this.currentShop.shop_id
      const freightItem = this.freightTemplate.find(item => String(item.id) === String(this.wForm.freight_template_id))
      if (!freightItem) {
        this.$message.error('请选择有效的运费模板')
        return
      }
      if (this.wechatReturnAddressInvalid) {
        this.$message.error('已保存的售后地址不可用，请重新选择')
        return
      }
      if (this.wechatStaleBrandKeys.length) {
        try {
          await this.$confirm(`有 ${this.wechatStaleBrandKeys.length} 条历史品牌映射不属于当前策略。确认清理后保存店铺资源？`, '确认清理历史品牌映射', { type: 'warning' })
        } catch (error) {
          return
        }
      }
      if (!this.isCurrentWechatEdit(requestId, shopId)) return
      const strategyIds = new Set(this.wechatEffectiveCategoryIds.map(id => String(this.getSecondCategoryId(id))))
      const brandKeyValues = {}
      Object.entries(this.wechatBrandSnapshot).forEach(([key, brand]) => {
        const secondId = String(this.getSecondCategoryId(key))
        if (strategyIds.has(secondId) && brand?.brand_id && !brandKeyValues[secondId]) brandKeyValues[secondId] = brand
      })
      this.wSelectedCateList.forEach(item => {
        const categoryId = String(item.category_id)
        delete brandKeyValues[categoryId]
        if (item.brand?.brand_id) {
          brandKeyValues[categoryId] = {
            brand_id: item.brand.brand_id,
            brand_name: item.brand.name_cn || item.brand.brand_name
          }
        }
      })
      const params = {
        shop_id: shopId,
        shop_type: 7,
        freight_template_id: this.wForm.freight_template_id,
        freight_template_name: freightItem.template_name,
        freight_insurance: this.wForm.freight_insurance ? 1 : 0,
        return_address_id: this.wForm.return_address_id,
        brandKeyValues
      }
      this.sLoading = true
      try {
        const res = await saveBlindBoxResources(params)
        if (!this.isCurrentWechatEdit(requestId, shopId)) return
        if (res?.code !== 200) throw new Error(res?.message || '保存失败')
        this.closeEdit()
        this.$message.success('保存成功')
        await this.refreshBlindBoxList()
      } catch (error) {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.$message.error(error?.message || '网络异常，保存失败')
      } finally {
        if (this.isCurrentWechatEdit(requestId, shopId)) this.sLoading = false
      }
    },
    closeEdit() {
      ++this.shopEditRequestId
      ++this.selectedCategoryRequestId
      ++this.brandCandidatesRequestId
      ++this.brandCategoryRequestId
      ++this.brandCategoryBatchRequestId
      this.editShow = false
      this.selectedCategoryShow = false
      this.brandCandidatesShow = false
      this.brandCategoryShow = false
      Object.keys(this.brandCandidateOptionsRequestId).forEach(key => { ++this.brandCandidateOptionsRequestId[key] })
      this.wechatCategoryDialogShow = false
      this.wechatBrandDialogShow = false
      this.brandCategorySelection = []
      this.brandCategoryBatchLoading = false
      this.brandCategoryBatchMode = ''
      this.brandCategoryBatchActiveId = ''
      this.shopEditSource = null
      this.shopStrategyDetailLoading = false
      this.shopStrategyDetailError = ''
      this.shopResourcesLoading = false
      this.shopResourcesError = ''
      this.categorySummaryLoading = false
      this.categorySummaryError = ''
      this.selCateSub = []
      this.selCateSubOptions = []
      this.brandObjCache = {}
      this.sLoading = false
    }
  }
}
</script>

<style scoped>
.w120{
  width: 120px;
}
.w160{
  width: 160px;
}

.gx-bb__notice {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 16px;
  background: rgba(251, 146, 60, 0.07);
  border: 1px solid rgba(251, 146, 60, 0.3);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  line-height: 1.7;
}
.gx-bb__plat-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
  margin-bottom: 14px;
}
.gx-bb__plat-tab {
  padding: 9px 22px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  background: rgb(255, 255, 255);
  color: rgb(102, 102, 102);
  font-weight: 400;
  transition: 0.15s;
}
.gx-bb__plat-tab--on {
  border-color: currentcolor currentcolor rgb(200, 68, 60);
  color: rgb(200, 68, 60);
  font-weight: 600;
}

.gx-bb__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-bb__filter-tip{
  padding-top: 8px;
  border-top: 1px dashed rgb(236, 236, 236);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(153, 153, 153);
  line-height: 1.75;
}
.gx-bb__batch-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 14px;
  padding: 10px 14px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  color: rgb(102, 102, 102);
  font-size: 12px;
}
.gx-bb__spacer {
  flex: 1;
}
.gx-bb__btn {
  height: 30px;
  padding: 0px 22px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color:#666666;
}
.gx-bb__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-bb__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-bb__btn--danger {
  background: rgb(200, 68, 60);
  border: none;
  font-weight: 600;
  color: #FFFFFF;
}
.table-page-wrapper{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.page-wrap{
  padding: 10px 14px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
}
.gx-bb__table {
  background: #FFFFFF;
  overflow-x: auto;
}
.gx-bb__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-bb__table thead tr:nth-child(1){
  font-weight: 600;
}
.gx-bb__table thead tr:nth-child(2){
  font-weight: 500;
  vertical-align: middle;
  letter-spacing: 0.04em;
  line-height: 1.5;
}
.gx-bb__table th {
  padding: 7px 10px;
  text-align: center;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
  border-bottom: 1px solid rgb(224, 224, 236);
  letter-spacing: 0.04em;
  background: rgb(245, 240, 232);
  border-right: 1px solid rgb(224, 224, 236);
}
.gx-bb__table tr th:last-child{
  border-right: none;
}

.gx-bb__table td {
  padding: 12px 10px;
  vertical-align: middle;
  text-align: center;
  border-bottom: 1px solid rgb(245, 245, 245);
  background: rgb(255, 255, 255);
}
.gx-bb__table tbody tr:hover td {
  background: rgb(255,245,245);
}

.gx-bb__table th.bg-red{
  background: rgb(255, 245, 245);
}
.gx-bb__table td.bg-red{
  background: rgb(255, 250, 250) !important;
}
.gx-bb__th-dec{
  font-size: 10px;
  color: rgb(153, 153, 153);
  font-weight: 400;
}

.gx-bb__counts b {
  color: #1A1A2E;
}
.gx-bb__shop {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  text-align: left;
}
.gx-bb__shop-icon{
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(255, 255, 255);
  flex-shrink: 0;
}
.gx-bb__shop-name{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgb(26, 26, 46);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-bb__shop-id {
    font-family: "JetBrains Mono", monospace;
    font-size: 10px;
    color: rgb(153, 153, 153);
}
.gx-bb__quota{
  display: flex;
  justify-content: center;
  align-items: center;
}
.gx-bb__quota-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px;
}
.gx-bb__quota-item~.gx-bb__quota-item{
  border-left: 1px solid rgb(236, 236, 236);
}
.gx-bb__td-num{
  font-family: "JetBrains Mono", monospace;
  font-size: 15px;
  font-weight: 700;
  color: rgb(26, 26, 46);
}
.gx-bb__td-label{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-top: 2px;
}
.gx-bb__rate{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gx-bb__rate-progress{
  position: relative;
  height: 5px;
  border-radius: 3px;
  background: rgb(235, 235, 235);
  margin-bottom: 1px;
  width: 80%;
  margin-top: 3px;
}
.gx-bb__rate-progress::before{
  content: "";
  position: absolute;
  top: -2px;
  left: 50%;
  width: 1px;
  height: 9px;
  background: rgb(170, 170, 170);
}
.gx-bb__rate-progress-bar{
  height: 100%;
  border-radius: 3px;
}
.gx-bb__rate-progress-bar--red{
  background: var(--gx-red);
}

.gx-bb__rate-progress-bar--green{
  background: var(--gx-green);
}
.gx-bb__rate-progress-half{
  text-align: center;
  font-size: 9px;
  color: rgb(153, 153, 153);
  margin-top: 1px;
  margin-bottom: 2px;
}
.gx-bb__tag {
  padding: 2px 8px;
  border-radius: 3px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
}
.gx-bb__tag--mi{
  padding: 1px 7px;
  font-size: 10px;
}
.gx-bb__tag--danger{
  padding: 2px 8px;
  border-radius: 3px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-size: 11px;
  color: rgb(200, 68, 60);
}
.gx-bb__tag--warn {
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  color: rgb(251, 146, 60);
}
.gx-bb__tag--info {
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
}
.gx-bb__tag--success {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
.gx-bb__tag--editable {
  margin-left: 6px;
  padding: 1px 6px;
  font-size: 10px;
  background: rgba(212, 169, 70, .14);
  border: 1px solid rgba(212, 169, 70, .38);
  color: #A9822B;
}
.gx-bb__switch {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  position: relative;
  transition: background .2s;
  display: inline-flex;
  align-items: center;
  padding: 0 2px;
  box-sizing: border-box;
}
.gx-bb__switch--on {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  box-shadow: rgba(255, 77, 79, 0.3) 0px 0px 8px;
}
.gx-bb__switch-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
  transition: transform .2s;
}
.gx-bb__switch--on .gx-bb__switch-dot {
  transform: translateX(16px);
}
.gx-bb__ops {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
}
.gx-bb__op {
  height: 24px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  color: #4A4A6A;
  transition: all .15s;
}
.gx-bb__op:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.gx-bb__op--edit {
  border: none;
  background: transparent;
  color: rgb(200, 68, 60);
}
.gx-bb__op--edit:hover {
 text-decoration: underline;
}
.gx-bb__empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #6A6A8A;
}

/* 弹窗 */
.gx-bb__modal-box--xl {
  max-width: 900px;
  min-height: 670px;
}
.gx-modal-head-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gx-bb__form {
  display: flex;
  flex-direction: column;
}
.gx-bb__form :deep(.el-form-item){
  margin-bottom: 10px;
}
.gx-bb__form :deep(.el-form-item__label){
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--gx-black);
  padding: 0 8px 0 0;
}
.gx-bb__form :deep(.el-input__inner){
  color: var(--gx-black);
}

/* 弹窗内带底色的浅红按钮 */
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red) {
  background: rgb(255, 245, 245);
  border-color: rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red:hover),
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red:focus) {
  background: rgb(255, 236, 234);
  border-color: rgb(255, 178, 170);
  color: rgb(200, 68, 60);
}
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red.is-disabled),
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red.is-disabled:hover),
.gx-bb__form :deep(.el-button.gx-bb__btn-soft-red.is-disabled:focus) {
  background: #F7F7F9;
  border-color: #E0E0EC;
  color: #C0C4CC;
}

.gx-bb__publish-cascader :deep(.el-input__inner::placeholder),
.gx-bb__blacklist-cascader :deep(.el-input__inner::placeholder) {
  color: transparent;
}

.gx-bb__category-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 28px;
}
.gx-bb__category-summary :deep(.el-button + .el-button) {
  margin-left: 0;
}
.gx-bb__category-preview {
  flex: 0 0 100%;
  color: #6A6A8A;
  min-width: 0;
  overflow-wrap: anywhere;
}
.gx-bb__category-dialog {
  min-height: 100px;
  max-height: 60vh;
  //overflow-y: auto;
}
.gx-bb__category-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.gx-bb__category-toolbar :deep(.el-input) {
  flex: 1;
}
.gx-bb__category-toolbar :deep(.el-select) {
  width: 150px;
  flex: 0 0 auto;
}
.gx-bb__brand-select {
  width: 100%;
}
.gx-bb__dialog-batch-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.gx-bb__batch-count {
  flex: 1 1 260px;
  margin-right: auto;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-bb__category-tag {
  margin-left: 6px;
}
.gx-bb__dialog-title-tag {
  margin-left: 8px;
}
.gx-bb__category-pager {
  margin-top: 10px;
}
.gx-bb__category-pager-controls {
  position: relative;
}
.gx-bb__category-pager-blocker {
  position: absolute;
  inset: 0;
  z-index: 2;
  cursor: not-allowed;
}
.gx-bb__category-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f4;
}
.gx-bb__category-name {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
.gx-bb__category-name small {
  color: #9093a5;
  margin-left: 5px;
}
.gx-bb__category-name em {
  color: #f87171;
  font-style: normal;
  margin-left: 5px;
}

.gx-bb__tip {
  font-size: 11px;
  color: #6A6A8A;
  line-height: 1.6;
}
.gx-bb__group-shared {
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  color: #909399;
  font-size: 11px;
  line-height: 18px;
}
.gx-bb__group-count {
  margin-left: 6px;
  color: #909399;
  font-size: 11px;
}
.gx-bb__price-range {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-bb__price-range-label,
.gx-bb__price-range-unit,
.gx-bb__price-range-sep {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-bb__price-range-input {
  width: 120px;
}
.gx-bb__inline-field {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.gx-bb__count-input {
  width: 90px;
}
.gx-bb__readonly-text {
  font-size: 12px;
  color: #1A1A2E;
  line-height: 28px;
}
.gx-bb__tip--red {
  color: #F87171;
}
.gx-bb__section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1A1A2E;
  margin: 4px 0 12px;
  padding-left: 10px;
  border-left: 3px solid #D4A946;
}

</style>

<!-- 候选类目弹窗：el-dialog 外壳套用“编辑盲盒配置”的头部/底部样式（弹窗挂在 body 下，不能用 scoped） -->
<style>
.gx-bb__candidates-dialog {
  border-radius: 10px;
  overflow: hidden;
}
.gx-bb__candidates-dialog .el-dialog__body {
  padding: 18px;
}
.gx-bb__candidates-dialog .el-dialog__footer {
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
  background: rgb(245, 240, 232);
}
</style>
